const isoglcodes = [
  {
    Code: 10010,
    Description: 'Air Conditioning Equipment--Dealers or Distributors Only',
    URL: 'https://www.insurancexdate.com/gl/10010',
  },
  {
    Code: 10015,
    Description: 'Amusement Centers',
    URL: 'https://www.insurancexdate.com/gl/10015',
  },
  {
    Code: 10020,
    Description: 'Amusement Parks',
    URL: 'https://www.insurancexdate.com/gl/10020',
  },
  {
    Code: 10026,
    Description: 'Antique Stores',
    URL: 'https://www.insurancexdate.com/gl/10026',
  },
  {
    Code: 10036,
    Description: 'Anhydrous Ammonia Dealers and Distributors',
    URL: 'https://www.insurancexdate.com/gl/10036',
  },
  {
    Code: 10040,
    Description: 'Appliance Distributors--Household Type',
    URL: 'https://www.insurancexdate.com/gl/10040',
  },
  {
    Code: 10042,
    Description: 'Appliance Stores--Household Type',
    URL: 'https://www.insurancexdate.com/gl/10042',
  },
  {
    Code: 10052,
    Description: 'Archery Ranges--Indoor',
    URL: 'https://www.insurancexdate.com/gl/10052',
  },
  {
    Code: 10054,
    Description: 'Archery Ranges--Other Than Indoor',
    URL: 'https://www.insurancexdate.com/gl/10054',
  },
  {
    Code: 10060,
    Description: 'Army and Navy Stores',
    URL: 'https://www.insurancexdate.com/gl/10060',
  },
  {
    Code: 10065,
    Description: 'Art Galleries--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/10065',
  },
  {
    Code: 10066,
    Description: 'Art Galleries--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/10066',
  },
  {
    Code: 10070,
    Description: 'Automobile Parts and Supplies Distributors',
    URL: 'https://www.insurancexdate.com/gl/10070',
  },
  {
    Code: 10071,
    Description: 'Automobile Parts and Supplies Stores',
    URL: 'https://www.insurancexdate.com/gl/10071',
  },
  {
    Code: 10072,
    Description: 'Automobile Quick Lubrication Services',
    URL: 'https://www.insurancexdate.com/gl/10072',
  },
  {
    Code: 10073,
    Description: 'Automobile Repair or Service Shops',
    URL: 'https://www.insurancexdate.com/gl/10073',
  },
  {
    Code: 10075,
    Description: 'Automobile Repair Shops--Self-Service',
    URL: 'https://www.insurancexdate.com/gl/10075',
  },
  {
    Code: 10100,
    Description: 'Bakeries',
    URL: 'https://www.insurancexdate.com/gl/10100',
  },
  {
    Code: 10101,
    Description: 'Boat Dealers',
    URL: 'https://www.insurancexdate.com/gl/10101',
  },
  {
    Code: 10105,
    Description: 'Boat Storage and Moorage',
    URL: 'https://www.insurancexdate.com/gl/10105',
  },
  {
    Code: 10107,
    Description: 'Boat Yards or Marinas--Public',
    URL: 'https://www.insurancexdate.com/gl/10107',
  },
  {
    Code: 10110,
    Description: 'Boats--Canoes or Rowboats--for Rent--Not Equipped with Motors',
    URL: 'https://www.insurancexdate.com/gl/10110',
  },
  {
    Code: 10111,
    Description: 'Barber or Beauty Shop Supplies Distributors',
    URL: 'https://www.insurancexdate.com/gl/10111',
  },
  {
    Code: 10113,
    Description: 'Barber Shops',
    URL: 'https://www.insurancexdate.com/gl/10113',
  },
  {
    Code: 10115,
    Description: 'Beauty Parlors and Hair Styling Salons',
    URL: 'https://www.insurancexdate.com/gl/10115',
  },
  {
    Code: 10117,
    Description: 'Boats--Motor or Sail--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/10117',
  },
  {
    Code: 10119,
    Description: 'Boats--Rented to Others NOC',
    URL: 'https://www.insurancexdate.com/gl/10119',
  },
  {
    Code: 10120,
    Description: 'Bathhouses or Bathing Pavilions',
    URL: 'https://www.insurancexdate.com/gl/10120',
  },
  {
    Code: 10130,
    Description: 'Bazaars--Operated by the Insured--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/10130',
  },
  {
    Code: 10132,
    Description: 'Bazaars--Operated by the Insured--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/10132',
  },
  {
    Code: 10133,
    Description: 'Beach Chairs and Umbrellas--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/10133',
  },
  {
    Code: 10135,
    Description: 'Beaches--Bathing--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/10135',
  },
  {
    Code: 10140,
    Description: 'Beverage Distributors--Alcoholic Other Than Beer',
    URL: 'https://www.insurancexdate.com/gl/10140',
  },
  {
    Code: 10141,
    Description: 'Beverage Distributors--Nonalcoholic and Beer',
    URL: 'https://www.insurancexdate.com/gl/10141',
  },
  {
    Code: 10145,
    Description: 'Beverage Stores--Liquor and Wine',
    URL: 'https://www.insurancexdate.com/gl/10145',
  },
  {
    Code: 10146,
    Description: 'Beverage Stores--Soft Drinks and Beer',
    URL: 'https://www.insurancexdate.com/gl/10146',
  },
  {
    Code: 10150,
    Description: 'Bicycle Stores--Sales and Servicing',
    URL: 'https://www.insurancexdate.com/gl/10150',
  },
  {
    Code: 10151,
    Description: 'Bicycles--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/10151',
  },
  {
    Code: 10160,
    Description: 'Billiard or Pool Halls',
    URL: 'https://www.insurancexdate.com/gl/10160',
  },
  {
    Code: 10204,
    Description: 'Books and Magazines Stores--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/10204',
  },
  {
    Code: 10205,
    Description: 'Books and Magazines Stores--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/10205',
  },
  {
    Code: 10220,
    Description: 'Bowling Lanes',
    URL: 'https://www.insurancexdate.com/gl/10220',
  },
  {
    Code: 10255,
    Description: 'Building Material Dealers--Other Than Secondhand Material',
    URL: 'https://www.insurancexdate.com/gl/10255',
  },
  {
    Code: 10256,
    Description: 'Building Material Dealers--Secondhand Material',
    URL: 'https://www.insurancexdate.com/gl/10256',
  },
  {
    Code: 10257,
    Description: 'Building Material Distributors',
    URL: 'https://www.insurancexdate.com/gl/10257',
  },
  {
    Code: 10309,
    Description: 'Camera and Photographic Equipment Stores',
    URL: 'https://www.insurancexdate.com/gl/10309',
  },
  {
    Code: 10315,
    Description: 'Camper or Travel Trailer Sales Agencies',
    URL: 'https://www.insurancexdate.com/gl/10315',
  },
  {
    Code: 10331,
    Description: 'Campgrounds--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/10331',
  },
  {
    Code: 10332,
    Description: 'Campgrounds--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/10332',
  },
  {
    Code: 10352,
    Description: 'Candy or Confectionery Stores',
    URL: 'https://www.insurancexdate.com/gl/10352',
  },
  {
    Code: 10367,
    Description: 'Car Washes--Other Than Self-Service',
    URL: 'https://www.insurancexdate.com/gl/10367',
  },
  {
    Code: 10368,
    Description: 'Car Washes--Self-Service',
    URL: 'https://www.insurancexdate.com/gl/10368',
  },
  {
    Code: 10375,
    Description: 'Carnival or Circus Companies',
    URL: 'https://www.insurancexdate.com/gl/10375',
  },
  {
    Code: 10378,
    Description: "Carnivals--Outside (Sponsor's Risk Only) Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/10378',
  },
  {
    Code: 10379,
    Description: "Carnivals--Outside (Sponsor's Risk Only) Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/10379',
  },
  {
    Code: 10380,
    Description: "Carnivals or Circuses--in Tents (Sponsor's Risk Only) Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/10380',
  },
  {
    Code: 10381,
    Description: "Carnivals or Circuses--in Tents (Sponsor's Risk Only) Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/10381',
  },
  {
    Code: 11007,
    Description: 'Carpet, Rug or Upholstery Cleaning--Shop Only',
    URL: 'https://www.insurancexdate.com/gl/11007',
  },
  {
    Code: 11020,
    Description: 'Catalog or Premium Coupon Redemption Stores',
    URL: 'https://www.insurancexdate.com/gl/11020',
  },
  {
    Code: 11039,
    Description: 'Caterers',
    URL: 'https://www.insurancexdate.com/gl/11039',
  },
  {
    Code: 11052,
    Description: 'Chairs--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/11052',
  },
  {
    Code: 11101,
    Description: 'Chemical Distributors',
    URL: 'https://www.insurancexdate.com/gl/11101',
  },
  {
    Code: 11120,
    Description: "Children's Playcenter--Indoor",
    URL: 'https://www.insurancexdate.com/gl/11120',
  },
  {
    Code: 11126,
    Description: 'Clothing or Wearing Apparel Distributors',
    URL: 'https://www.insurancexdate.com/gl/11126',
  },
  {
    Code: 11127,
    Description: 'Clothing or Wearing Apparel Stores--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/11127',
  },
  {
    Code: 11128,
    Description: 'Clothing or Wearing Apparel Stores--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/11128',
  },
  {
    Code: 11138,
    Description: 'Clubs--Country or Golf',
    URL: 'https://www.insurancexdate.com/gl/11138',
  },
  {
    Code: 11155,
    Description: 'Collectibles and Memorabilia Stores',
    URL: 'https://www.insurancexdate.com/gl/11155',
  },
  {
    Code: 11160,
    Description: 'Computer Stores',
    URL: 'https://www.insurancexdate.com/gl/11160',
  },
  {
    Code: 11167,
    Description:
      'Concessionaires--Checkroom, Shoeshine or Toilet Concessions in Hotels, Restaurants, Railroad Stations, etc.',
    URL: 'https://www.insurancexdate.com/gl/11167',
  },
  {
    Code: 11168,
    Description: 'Concessionaires',
    URL: 'https://www.insurancexdate.com/gl/11168',
  },
  {
    Code: 11201,
    Description:
      'Contractors Equipment--Cranes, Derricks, Power Shovels and Equipment Incidental Thereto--Rented to Others with Operators',
    URL: 'https://www.insurancexdate.com/gl/11201',
  },
  {
    Code: 11202,
    Description:
      'Contractors Equipment--Cranes, Derricks, Power Shovels and Equipment Incidental Thereto--Rented to Others without Operators',
    URL: 'https://www.insurancexdate.com/gl/11202',
  },
  {
    Code: 11203,
    Description: 'Contractors Equipment Dealers--Ladders, Excluding Hoists, Scaffolds or Towers',
    URL: 'https://www.insurancexdate.com/gl/11203',
  },
  {
    Code: 11204,
    Description: 'Contractors Equipment Dealers--Ladders, Hoists, Scaffolds or Towers',
    URL: 'https://www.insurancexdate.com/gl/11204',
  },
  {
    Code: 11205,
    Description:
      'Contractors Equipment--Earth Moving Equipment Other Than Cranes, Derricks and Power Shovels--Rented to Others with Operators',
    URL: 'https://www.insurancexdate.com/gl/11205',
  },
  {
    Code: 11206,
    Description:
      'Contractors Equipment--Earth Moving Equipment Other Than Cranes, Derricks and Power Shovels--Rented to Others without Operators',
    URL: 'https://www.insurancexdate.com/gl/11206',
  },
  {
    Code: 11207,
    Description: 'Contractors Equipment--Excluding Automobiles--Rented to Others with Operators',
    URL: 'https://www.insurancexdate.com/gl/11207',
  },
  {
    Code: 11208,
    Description: 'Contractors Equipment--Excluding Automobiles--Rented to Others without Operators',
    URL: 'https://www.insurancexdate.com/gl/11208',
  },
  {
    Code: 11209,
    Description:
      'Contractors Equipment--Hod or Material Platform Hoists and Equipment Incidental Thereto--Rented to Others with Operators',
    URL: 'https://www.insurancexdate.com/gl/11209',
  },
  {
    Code: 11210,
    Description:
      'Contractors Equipment--Hod or Material Platform Hoists and Equipment Incidental Thereto--Rented to Others without Operators',
    URL: 'https://www.insurancexdate.com/gl/11210',
  },
  {
    Code: 11211,
    Description:
      'Contractors Equipment--Ladders, Scaffolds, Scaffolding, Sidewalk Bridges, Towers and Equipment Incidental Thereto--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/11211',
  },
  {
    Code: 11212,
    Description:
      'Contractors Equipment--Scaffolds, Sidewalk Bridges, Hod or Material Hoists, Towers--Rented to Others--Installation, Repair or Removal Operations Only',
    URL: 'https://www.insurancexdate.com/gl/11212',
  },
  {
    Code: 11213,
    Description:
      'Contractors Equipment--Steam Boilers, Compressors, Air Pressure Tanks, Pneumatic Tools and Equipment Incidental Thereto--Rented to Others with Operators',
    URL: 'https://www.insurancexdate.com/gl/11213',
  },
  {
    Code: 11214,
    Description:
      'Contractors Equipment--Steam Boilers, Compressors, Air Pressure Tanks, Pneumatic Tools and Equipment Incidental Thereto--Rented to Others without Operators',
    URL: 'https://www.insurancexdate.com/gl/11214',
  },
  {
    Code: 11222,
    Description: 'Copying and Duplicating Services--Retail',
    URL: 'https://www.insurancexdate.com/gl/11222',
  },
  {
    Code: 11234,
    Description: 'Cosmetic, Hair or Skin Preparation Stores',
    URL: 'https://www.insurancexdate.com/gl/11234',
  },
  {
    Code: 11248,
    Description: 'Cotton or Wool Merchants',
    URL: 'https://www.insurancexdate.com/gl/11248',
  },
  {
    Code: 11258,
    Description: 'Dairy Products or Butter and Egg Stores--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/11258',
  },
  {
    Code: 11259,
    Description: 'Dairy Products or Butter and Egg Stores--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/11259',
  },
  {
    Code: 11273,
    Description: 'Dance Halls, Ballrooms or Discotheques--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/11273',
  },
  {
    Code: 11274,
    Description: 'Dance Halls, Ballrooms or Discotheques--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/11274',
  },
  {
    Code: 11288,
    Description: 'Delicatessens',
    URL: 'https://www.insurancexdate.com/gl/11288',
  },
  {
    Code: 12014,
    Description: 'Dental Laboratories',
    URL: 'https://www.insurancexdate.com/gl/12014',
  },
  {
    Code: 12356,
    Description: 'Department or Discount Stores',
    URL: 'https://www.insurancexdate.com/gl/12356',
  },
  {
    Code: 12361,
    Description: 'Distributors--Food or Drink',
    URL: 'https://www.insurancexdate.com/gl/12361',
  },
  {
    Code: 12362,
    Description: 'Distributors--No Food or Drink',
    URL: 'https://www.insurancexdate.com/gl/12362',
  },
  {
    Code: 12373,
    Description: 'Drug Distributors',
    URL: 'https://www.insurancexdate.com/gl/12373',
  },
  {
    Code: 12374,
    Description: 'Drugstores--No Table or Counter Service for Beverage or Food',
    URL: 'https://www.insurancexdate.com/gl/12374',
  },
  {
    Code: 12375,
    Description: 'Drugstores',
    URL: 'https://www.insurancexdate.com/gl/12375',
  },
  {
    Code: 12391,
    Description: 'Electrical Equipment Distributors',
    URL: 'https://www.insurancexdate.com/gl/12391',
  },
  {
    Code: 12393,
    Description: 'Electronics Store',
    URL: 'https://www.insurancexdate.com/gl/12393',
  },
  {
    Code: 12467,
    Description: 'Equipment, Fixtures or Supplies--for Bars, Hotels, Offices, Restaurants or Stores--Distributors',
    URL: 'https://www.insurancexdate.com/gl/12467',
  },
  {
    Code: 12509,
    Description: 'Fabric Distributors',
    URL: 'https://www.insurancexdate.com/gl/12509',
  },
  {
    Code: 12510,
    Description: 'Fabric Stores',
    URL: 'https://www.insurancexdate.com/gl/12510',
  },
  {
    Code: 12583,
    Description: 'Feed, Grain or Hay Dealers',
    URL: 'https://www.insurancexdate.com/gl/12583',
  },
  {
    Code: 12651,
    Description: 'Fence Dealers',
    URL: 'https://www.insurancexdate.com/gl/12651',
  },
  {
    Code: 12683,
    Description: 'Fertilizer Dealers and Distributors',
    URL: 'https://www.insurancexdate.com/gl/12683',
  },
  {
    Code: 12707,
    Description: 'Fire Protection Equipment Dealers and Distributors',
    URL: 'https://www.insurancexdate.com/gl/12707',
  },
  {
    Code: 12797,
    Description: 'Floor Covering Distributors',
    URL: 'https://www.insurancexdate.com/gl/12797',
  },
  {
    Code: 12805,
    Description: 'Floor Covering Stores',
    URL: 'https://www.insurancexdate.com/gl/12805',
  },
  {
    Code: 12841,
    Description: 'Florists',
    URL: 'https://www.insurancexdate.com/gl/12841',
  },
  {
    Code: 12927,
    Description: 'Formal Wear or Costumes--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/12927',
  },
  {
    Code: 13049,
    Description: 'Frozen Food--Distributors',
    URL: 'https://www.insurancexdate.com/gl/13049',
  },
  {
    Code: 13111,
    Description: 'Fruit or Vegetable Dealers',
    URL: 'https://www.insurancexdate.com/gl/13111',
  },
  {
    Code: 13112,
    Description: 'Fruit or Vegetable Distributors',
    URL: 'https://www.insurancexdate.com/gl/13112',
  },
  {
    Code: 13201,
    Description: 'Fuel Dealers or Distributors--Coal or Wood',
    URL: 'https://www.insurancexdate.com/gl/13201',
  },
  {
    Code: 13204,
    Description: 'Fuel Oil or Kerosene Dealers',
    URL: 'https://www.insurancexdate.com/gl/13204',
  },
  {
    Code: 13205,
    Description: 'Fuel Oil or Kerosene Distributors',
    URL: 'https://www.insurancexdate.com/gl/13205',
  },
  {
    Code: 13314,
    Description: 'Fur--Garments and Pelts--Distributors',
    URL: 'https://www.insurancexdate.com/gl/13314',
  },
  {
    Code: 13351,
    Description: 'Furniture Stores--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/13351',
  },
  {
    Code: 13352,
    Description: 'Furniture Stores--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/13352',
  },
  {
    Code: 13410,
    Description: 'Gas Dealers--LPG',
    URL: 'https://www.insurancexdate.com/gl/13410',
  },
  {
    Code: 13411,
    Description: 'Gas Dealers or Distributors',
    URL: 'https://www.insurancexdate.com/gl/13411',
  },
  {
    Code: 13412,
    Description: 'Gas Distributors--LPG',
    URL: 'https://www.insurancexdate.com/gl/13412',
  },
  {
    Code: 13453,
    Description: 'Gasoline Stations--Full Service',
    URL: 'https://www.insurancexdate.com/gl/13453',
  },
  {
    Code: 13454,
    Description: 'Gasoline Stations--Self-Service',
    URL: 'https://www.insurancexdate.com/gl/13454',
  },
  {
    Code: 13455,
    Description: 'Gasoline Stations--Self and Full Service Combined',
    URL: 'https://www.insurancexdate.com/gl/13455',
  },
  {
    Code: 13506,
    Description: 'Gift Shops--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/13506',
  },
  {
    Code: 13507,
    Description: 'Gift Shops--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/13507',
  },
  {
    Code: 13590,
    Description: 'Glass Dealers and Glaziers',
    URL: 'https://www.insurancexdate.com/gl/13590',
  },
  {
    Code: 13621,
    Description: 'Grain Milling',
    URL: 'https://www.insurancexdate.com/gl/13621',
  },
  {
    Code: 13670,
    Description: 'Grocery Distributors',
    URL: 'https://www.insurancexdate.com/gl/13670',
  },
  {
    Code: 13673,
    Description: 'Grocery Stores',
    URL: 'https://www.insurancexdate.com/gl/13673',
  },
  {
    Code: 13715,
    Description: 'Hardware and Tool Distributors',
    URL: 'https://www.insurancexdate.com/gl/13715',
  },
  {
    Code: 13716,
    Description: 'Hardware Stores',
    URL: 'https://www.insurancexdate.com/gl/13716',
  },
  {
    Code: 13720,
    Description: 'Health or Natural Food Stores',
    URL: 'https://www.insurancexdate.com/gl/13720',
  },
  {
    Code: 13759,
    Description: 'Hearing Aid Stores',
    URL: 'https://www.insurancexdate.com/gl/13759',
  },
  {
    Code: 13930,
    Description: 'Heating or Combined Heating and Air Conditioning Equipment--Dealers or Distributors Only',
    URL: 'https://www.insurancexdate.com/gl/13930',
  },
  {
    Code: 14068,
    Description: 'Hide Dealers and Distributors--Raw',
    URL: 'https://www.insurancexdate.com/gl/14068',
  },
  {
    Code: 14101,
    Description: "Hobby, Craft or Artists' Supply Stores",
    URL: 'https://www.insurancexdate.com/gl/14101',
  },
  {
    Code: 14279,
    Description: 'Home Improvement Stores',
    URL: 'https://www.insurancexdate.com/gl/14279',
  },
  {
    Code: 14401,
    Description: 'Ice Cream Stores',
    URL: 'https://www.insurancexdate.com/gl/14401',
  },
  {
    Code: 14405,
    Description: 'Ice Dealers and Distributors',
    URL: 'https://www.insurancexdate.com/gl/14405',
  },
  {
    Code: 14527,
    Description: 'Janitorial Supplies--Dealers or Distributors',
    URL: 'https://www.insurancexdate.com/gl/14527',
  },
  {
    Code: 14655,
    Description: 'Jewelry Stores or Distributors',
    URL: 'https://www.insurancexdate.com/gl/14655',
  },
  {
    Code: 14731,
    Description: 'Laundries and Dry Cleaners--Self-Service',
    URL: 'https://www.insurancexdate.com/gl/14731',
  },
  {
    Code: 14732,
    Description: 'Laundry and Dry Cleaning or Dyeing Receiving Stations',
    URL: 'https://www.insurancexdate.com/gl/14732',
  },
  {
    Code: 14733,
    Description: 'Laundry and Dry Cleaning Stores',
    URL: 'https://www.insurancexdate.com/gl/14733',
  },
  {
    Code: 14734,
    Description: 'Laundry Rental Service',
    URL: 'https://www.insurancexdate.com/gl/14734',
  },
  {
    Code: 14855,
    Description: 'Livestock Dealers or Commission Merchants',
    URL: 'https://www.insurancexdate.com/gl/14855',
  },
  {
    Code: 14913,
    Description: 'Locksmiths',
    URL: 'https://www.insurancexdate.com/gl/14913',
  },
  {
    Code: 15060,
    Description: 'Machinery or Equipment Dealers--Construction or Industrial--Mobile Type',
    URL: 'https://www.insurancexdate.com/gl/15060',
  },
  {
    Code: 15061,
    Description: 'Machinery or Equipment Dealers--Farm Type',
    URL: 'https://www.insurancexdate.com/gl/15061',
  },
  {
    Code: 15062,
    Description: 'Machinery or Equipment Dealers',
    URL: 'https://www.insurancexdate.com/gl/15062',
  },
  {
    Code: 15063,
    Description: 'Machinery or Equipment Dealers--Yard or Garden Type',
    URL: 'https://www.insurancexdate.com/gl/15063',
  },
  {
    Code: 15070,
    Description: 'Mail Box or Packaging Stores',
    URL: 'https://www.insurancexdate.com/gl/15070',
  },
  {
    Code: 15119,
    Description: "Markets--Not Open Air (Lessor's Risk Only) Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/15119',
  },
  {
    Code: 15120,
    Description: "Markets--Not Open Air (Lessor's Risk Only) Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/15120',
  },
  {
    Code: 15123,
    Description: "Markets--Open Air (Lessor's Risk Only) Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/15123',
  },
  {
    Code: 15124,
    Description: "Markets--Open Air (Lessor's Risk Only) Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/15124',
  },
  {
    Code: 15188,
    Description: 'Oil or Gas Well Supplies or Equipment Dealers--Secondhand',
    URL: 'https://www.insurancexdate.com/gl/15188',
  },
  {
    Code: 15223,
    Description: 'Meat, Fish, Poultry or Seafood--Distributors',
    URL: 'https://www.insurancexdate.com/gl/15223',
  },
  {
    Code: 15224,
    Description: 'Meat, Fish, Poultry or Seafood Stores',
    URL: 'https://www.insurancexdate.com/gl/15224',
  },
  {
    Code: 15300,
    Description: 'Medical, Hospital and Surgical Equipment and Supplies--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/15300',
  },
  {
    Code: 15314,
    Description: 'Medical, Hospital and Surgical Supply Stores',
    URL: 'https://www.insurancexdate.com/gl/15314',
  },
  {
    Code: 15404,
    Description: 'Metal Dealers or Distributors--Nonstructural',
    URL: 'https://www.insurancexdate.com/gl/15404',
  },
  {
    Code: 15405,
    Description: 'Metal Dealers or Distributors--Structural',
    URL: 'https://www.insurancexdate.com/gl/15405',
  },
  {
    Code: 15406,
    Description: 'Metal Scrap Dealers',
    URL: 'https://www.insurancexdate.com/gl/15406',
  },
  {
    Code: 15488,
    Description: 'Mobile Home Sales Agencies',
    URL: 'https://www.insurancexdate.com/gl/15488',
  },
  {
    Code: 15538,
    Description: 'Musical Instrument Stores',
    URL: 'https://www.insurancexdate.com/gl/15538',
  },
  {
    Code: 15600,
    Description: 'Nail Salons',
    URL: 'https://www.insurancexdate.com/gl/15600',
  },
  {
    Code: 15607,
    Description: 'Newspaper or Magazine Distributors',
    URL: 'https://www.insurancexdate.com/gl/15607',
  },
  {
    Code: 15608,
    Description: 'Newsstands',
    URL: 'https://www.insurancexdate.com/gl/15608',
  },
  {
    Code: 15656,
    Description: 'Nightclubs, Cabarets and Comedy Clubs',
    URL: 'https://www.insurancexdate.com/gl/15656',
  },
  {
    Code: 15699,
    Description: 'Nursery--Garden',
    URL: 'https://www.insurancexdate.com/gl/15699',
  },
  {
    Code: 15733,
    Description: 'Oil Refineries',
    URL: 'https://www.insurancexdate.com/gl/15733',
  },
  {
    Code: 15839,
    Description: 'Optical Goods Stores',
    URL: 'https://www.insurancexdate.com/gl/15839',
  },
  {
    Code: 15991,
    Description: 'Paint, Wallpaper or Wallcovering Stores',
    URL: 'https://www.insurancexdate.com/gl/15991',
  },
  {
    Code: 15993,
    Description: 'Painting, Picture or Frame Stores',
    URL: 'https://www.insurancexdate.com/gl/15993',
  },
  {
    Code: 16005,
    Description: 'Paper Products Distributors',
    URL: 'https://www.insurancexdate.com/gl/16005',
  },
  {
    Code: 16009,
    Description: 'Paper, Rag or Rubber Stock Dealers and Distributors--Secondhand',
    URL: 'https://www.insurancexdate.com/gl/16009',
  },
  {
    Code: 16402,
    Description: 'Pet Grooming',
    URL: 'https://www.insurancexdate.com/gl/16402',
  },
  {
    Code: 16403,
    Description: 'Pet Stores',
    URL: 'https://www.insurancexdate.com/gl/16403',
  },
  {
    Code: 16404,
    Description: 'Pet Training',
    URL: 'https://www.insurancexdate.com/gl/16404',
  },
  {
    Code: 16471,
    Description: 'Photographers',
    URL: 'https://www.insurancexdate.com/gl/16471',
  },
  {
    Code: 16501,
    Description: 'Plastic or Rubber Supply Goods Distributors',
    URL: 'https://www.insurancexdate.com/gl/16501',
  },
  {
    Code: 16527,
    Description: 'Plumbing Supplies and Fixtures Dealers and Distributors',
    URL: 'https://www.insurancexdate.com/gl/16527',
  },
  {
    Code: 16588,
    Description: 'Printers or Electrotypers Supplies--Distributors',
    URL: 'https://www.insurancexdate.com/gl/16588',
  },
  {
    Code: 16604,
    Description: 'Produce Handling or Packing',
    URL: 'https://www.insurancexdate.com/gl/16604',
  },
  {
    Code: 16670,
    Description: 'Racquet Sports and Handball Facilities--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/16670',
  },
  {
    Code: 16676,
    Description: 'Music Stores--Pre-Recorded',
    URL: 'https://www.insurancexdate.com/gl/16676',
  },
  {
    Code: 16694,
    Description: 'Recreational Vehicle Dealers',
    URL: 'https://www.insurancexdate.com/gl/16694',
  },
  {
    Code: 16705,
    Description: 'Refrigeration Equipment--Dealers and Distributors Only--Commercial',
    URL: 'https://www.insurancexdate.com/gl/16705',
  },
  {
    Code: 16722,
    Description: 'Rental Stores',
    URL: 'https://www.insurancexdate.com/gl/16722',
  },
  {
    Code: 16723,
    Description: 'Rental Stores--Machinery or Equipment--Rented to Others on a Long-Term Basis',
    URL: 'https://www.insurancexdate.com/gl/16723',
  },
  {
    Code: 16750,
    Description: 'Internet Retailers',
    URL: 'https://www.insurancexdate.com/gl/16750',
  },
  {
    Code: 16751,
    Description: 'Internet Auctions',
    URL: 'https://www.insurancexdate.com/gl/16751',
  },
  {
    Code: 16819,
    Description: 'Restaurants--Operated by Concessionaires--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/16819',
  },
  {
    Code: 16820,
    Description: 'Restaurants--Operated by Concessionaires--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/16820',
  },
  {
    Code: 16881,
    Description: 'Secondhand or Salvage Dealers and Distributors',
    URL: 'https://www.insurancexdate.com/gl/16881',
  },
  {
    Code: 16890,
    Description: 'Seed Merchants--Excluding Erroneous Delivery, Error in Mixture and Germination Failure',
    URL: 'https://www.insurancexdate.com/gl/16890',
  },
  {
    Code: 16891,
    Description: 'Seed Merchants--Erroneous Delivery, Error in Mixture and Resulting Germination Failure',
    URL: 'https://www.insurancexdate.com/gl/16891',
  },
  {
    Code: 16892,
    Description: 'Seed Merchants--Erroneous Delivery, and Error in Mixture (Excluding Germination Failure)',
    URL: 'https://www.insurancexdate.com/gl/16892',
  },
  {
    Code: 16900,
    Description: 'Restaurants--with No Sale of Alcoholic Beverages--with Table Service',
    URL: 'https://www.insurancexdate.com/gl/16900',
  },
  {
    Code: 16901,
    Description: 'Restaurants--with No Sale of Alcoholic Beverages--without Table Service with Seating',
    URL: 'https://www.insurancexdate.com/gl/16901',
  },
  {
    Code: 16902,
    Description: 'Restaurants--with No Sale of Alcoholic Beverages--without Seating',
    URL: 'https://www.insurancexdate.com/gl/16902',
  },
  {
    Code: 16910,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are Less Than 30% of the Annual Receipts of the Restaurants--with Table Service',
    URL: 'https://www.insurancexdate.com/gl/16910',
  },
  {
    Code: 16911,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are Less Than 30% of the Annual Receipts of the Restaurants--without Table Service with Seating',
    URL: 'https://www.insurancexdate.com/gl/16911',
  },
  {
    Code: 16915,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 30% or More of But Less Than 75% of the Total Annual Receipts of the Restaurants--with Dance Floor',
    URL: 'https://www.insurancexdate.com/gl/16915',
  },
  {
    Code: 16916,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 30% or More of But Less Than 75% of the Total Annual Receipts of the Restaurants--without Dance Floor',
    URL: 'https://www.insurancexdate.com/gl/16916',
  },
  {
    Code: 16920,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--with Dance Floor: Table Service',
    URL: 'https://www.insurancexdate.com/gl/16920',
  },
  {
    Code: 16921,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--with Dance Floor: No Table Service',
    URL: 'https://www.insurancexdate.com/gl/16921',
  },
  {
    Code: 16930,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--without Dance Floor: Table Service',
    URL: 'https://www.insurancexdate.com/gl/16930',
  },
  {
    Code: 16931,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--with Tables--without Dance Floor: No Table Service',
    URL: 'https://www.insurancexdate.com/gl/16931',
  },
  {
    Code: 16940,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--Bar Service Only (No Tables): with Dance Floor',
    URL: 'https://www.insurancexdate.com/gl/16940',
  },
  {
    Code: 16941,
    Description:
      'Restaurants--with Sale of Alcoholic Beverages that are 75% or More of Total Annual Receipts of the Restaurants--Bar Service Only (No Tables): without Dance Floor',
    URL: 'https://www.insurancexdate.com/gl/16941',
  },
  {
    Code: 18078,
    Description: 'Ship Chandler Stores',
    URL: 'https://www.insurancexdate.com/gl/18078',
  },
  {
    Code: 18109,
    Description: 'Shoe Repair Shops',
    URL: 'https://www.insurancexdate.com/gl/18109',
  },
  {
    Code: 18110,
    Description: 'Shoe Stores',
    URL: 'https://www.insurancexdate.com/gl/18110',
  },
  {
    Code: 18200,
    Description: 'Spas or Personal Enhancement Facilities',
    URL: 'https://www.insurancexdate.com/gl/18200',
  },
  {
    Code: 18205,
    Description: 'Sporting Goods or Athletic Equipment Distributors',
    URL: 'https://www.insurancexdate.com/gl/18205',
  },
  {
    Code: 18206,
    Description: 'Sporting Goods or Athletic Equipment Stores',
    URL: 'https://www.insurancexdate.com/gl/18206',
  },
  {
    Code: 18335,
    Description: 'Stationery or Paper Products Stores',
    URL: 'https://www.insurancexdate.com/gl/18335',
  },
  {
    Code: 18435,
    Description: 'Stores--Food or Drink--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/18435',
  },
  {
    Code: 18436,
    Description: 'Stores--Food or Drink--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/18436',
  },
  {
    Code: 18437,
    Description: 'Stores: Retail NOC',
    URL: 'https://www.insurancexdate.com/gl/18437',
  },
  {
    Code: 18438,
    Description: 'Stores--No Food or Drink--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/18438',
  },
  {
    Code: 18501,
    Description: 'Supermarkets',
    URL: 'https://www.insurancexdate.com/gl/18501',
  },
  {
    Code: 18506,
    Description: 'Tailor Merchants--Men or Boys',
    URL: 'https://www.insurancexdate.com/gl/18506',
  },
  {
    Code: 18507,
    Description: 'Tailoring or Dressmaking Establishments--Custom',
    URL: 'https://www.insurancexdate.com/gl/18507',
  },
  {
    Code: 18570,
    Description: 'Tattoo Parlors',
    URL: 'https://www.insurancexdate.com/gl/18570',
  },
  {
    Code: 18575,
    Description: 'Telecommunication Equipment Providers',
    URL: 'https://www.insurancexdate.com/gl/18575',
  },
  {
    Code: 18616,
    Description: 'Tire Dealers',
    URL: 'https://www.insurancexdate.com/gl/18616',
  },
  {
    Code: 18707,
    Description: 'Tobacco Products Distributors',
    URL: 'https://www.insurancexdate.com/gl/18707',
  },
  {
    Code: 18708,
    Description: 'Tobacco Products Stores',
    URL: 'https://www.insurancexdate.com/gl/18708',
  },
  {
    Code: 18833,
    Description: 'Toy Distributors',
    URL: 'https://www.insurancexdate.com/gl/18833',
  },
  {
    Code: 18834,
    Description: 'Toy Stores',
    URL: 'https://www.insurancexdate.com/gl/18834',
  },
  {
    Code: 18911,
    Description: 'Variety Stores--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/18911',
  },
  {
    Code: 18912,
    Description: 'Variety Stores--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/18912',
  },
  {
    Code: 18920,
    Description: 'Video Stores',
    URL: 'https://www.insurancexdate.com/gl/18920',
  },
  {
    Code: 18991,
    Description: 'Warehouses--Mini-Warehouses',
    URL: 'https://www.insurancexdate.com/gl/18991',
  },
  {
    Code: 19007,
    Description: 'Washing Machines, Dryers or Ironers--Coin Meter Type',
    URL: 'https://www.insurancexdate.com/gl/19007',
  },
  {
    Code: 19051,
    Description: 'Water Softening Equipment--Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/19051',
  },
  {
    Code: 19061,
    Description: 'Portable Toilet Rentals',
    URL: 'https://www.insurancexdate.com/gl/19061',
  },
  {
    Code: 19795,
    Description: 'Trailer Dealers',
    URL: 'https://www.insurancexdate.com/gl/19795',
  },
  {
    Code: 19796,
    Description: 'Trailer Rental Agencies',
    URL: 'https://www.insurancexdate.com/gl/19796',
  },
  {
    Code: 40005,
    Description: 'Adult Day Care--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/40005',
  },
  {
    Code: 40006,
    Description: 'Adult Day Care--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/40006',
  },
  {
    Code: 40010,
    Description: 'Airports--Commercial',
    URL: 'https://www.insurancexdate.com/gl/40010',
  },
  {
    Code: 40015,
    Description: 'Airports--Private',
    URL: 'https://www.insurancexdate.com/gl/40015',
  },
  {
    Code: 40020,
    Description: 'Airport Control Towers--Not Operated Exclusively by the Federal Aviation Administration',
    URL: 'https://www.insurancexdate.com/gl/40020',
  },
  {
    Code: 40026,
    Description:
      'Airport--Lessees of Portions of Airports Engaged in the Sale of Aircraft or Accessories, Servicing or Repairing of Aircraft or Pilot Instructions',
    URL: 'https://www.insurancexdate.com/gl/40026',
  },
  {
    Code: 40031,
    Description: 'Ambulance Service, First Aid or Rescue Squads--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/40031',
  },
  {
    Code: 40032,
    Description: 'Ambulance Service, First Aid or Rescue Squads--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/40032',
  },
  {
    Code: 40040,
    Description: 'Amusement Devices',
    URL: 'https://www.insurancexdate.com/gl/40040',
  },
  {
    Code: 40041,
    Description: 'Amusement Devices--Operated in Connection with Carnivals or Fairs--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/40041',
  },
  {
    Code: 40042,
    Description: 'Amusement Devices--Operated in Connection with Carnivals or Fairs--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/40042',
  },
  {
    Code: 40045,
    Description: 'Animals--Draft',
    URL: 'https://www.insurancexdate.com/gl/40045',
  },
  {
    Code: 40046,
    Description: 'Animals--Saddle--for Rent',
    URL: 'https://www.insurancexdate.com/gl/40046',
  },
  {
    Code: 40047,
    Description: 'Animals--Saddle--Private',
    URL: 'https://www.insurancexdate.com/gl/40047',
  },
  {
    Code: 40059,
    Description: 'Athletic Games Sponsored by the Insured--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/40059',
  },
  {
    Code: 40061,
    Description: 'Athletic Games Sponsored by the Insured--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/40061',
  },
  {
    Code: 40063,
    Description: 'Athletic or Sports Contests--in Buildings--Lessees--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/40063',
  },
  {
    Code: 40064,
    Description: 'Athletic or Sports Contests--in Buildings--Lessees--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/40064',
  },
  {
    Code: 40066,
    Description: 'Athletic Programs--Amateur--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/40066',
  },
  {
    Code: 40067,
    Description: 'Athletic Programs--Amateur--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/40067',
  },
  {
    Code: 40069,
    Description: 'Athletic Teams--Professional or Semi-Professional',
    URL: 'https://www.insurancexdate.com/gl/40069',
  },
  {
    Code: 40072,
    Description: 'Beaches--Bathing--Not Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/40072',
  },
  {
    Code: 40075,
    Description: 'Bingo Games--in Public Halls or Theaters--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/40075',
  },
  {
    Code: 40101,
    Description: 'Blood Banks--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/40101',
  },
  {
    Code: 40102,
    Description: 'Blood Banks--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/40102',
  },
  {
    Code: 40111,
    Description: 'Boats--Canoes or Rowboats--Not for Rent--Not Equipped with Motors',
    URL: 'https://www.insurancexdate.com/gl/40111',
  },
  {
    Code: 40115,
    Description: 'Boats--Motor or Sail--Not for Rent',
    URL: 'https://www.insurancexdate.com/gl/40115',
  },
  {
    Code: 40117,
    Description: 'Boats--Not for Rent',
    URL: 'https://www.insurancexdate.com/gl/40117',
  },
  {
    Code: 40140,
    Description: 'Boats--Nonowned over 26 Feet',
    URL: 'https://www.insurancexdate.com/gl/40140',
  },
  {
    Code: 41001,
    Description: 'Boy or Girl Scout Councils',
    URL: 'https://www.insurancexdate.com/gl/41001',
  },
  {
    Code: 41210,
    Description: 'Bus Stations or Terminals',
    URL: 'https://www.insurancexdate.com/gl/41210',
  },
  {
    Code: 41421,
    Description: 'Camps--For-Profit',
    URL: 'https://www.insurancexdate.com/gl/41421',
  },
  {
    Code: 41422,
    Description: 'Camps--Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/41422',
  },
  {
    Code: 41510,
    Description: 'Caves--Tourist Attraction',
    URL: 'https://www.insurancexdate.com/gl/41510',
  },
  {
    Code: 41603,
    Description: 'Cemeteries--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/41603',
  },
  {
    Code: 41604,
    Description: 'Cemeteries--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/41604',
  },
  {
    Code: 41650,
    Description: 'Churches or Other Houses of Worship',
    URL: 'https://www.insurancexdate.com/gl/41650',
  },
  {
    Code: 41664,
    Description: 'Clubs--Horseback Riding--No Commercial Riding Instructions',
    URL: 'https://www.insurancexdate.com/gl/41664',
  },
  {
    Code: 41665,
    Description: 'Clubs--Racket Sports and Handball',
    URL: 'https://www.insurancexdate.com/gl/41665',
  },
  {
    Code: 41666,
    Description: 'Clubs--Swimming',
    URL: 'https://www.insurancexdate.com/gl/41666',
  },
  {
    Code: 41667,
    Description:
      'Clubs--Civic, Service or Social--Having Buildings or Premises Owned or Leased--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/41667',
  },
  {
    Code: 41668,
    Description: 'Clubs--Civic, Service or Social--Having Buildings or Premises Owned or Leased--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/41668',
  },
  {
    Code: 41670,
    Description:
      'Clubs--Civic, Service or Social--No Buildings or Premises Owned or Leased Except for Office Purposes--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/41670',
  },
  {
    Code: 41672,
    Description: "Conventions (Sponsor's Risk Only)--Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/41672',
  },
  {
    Code: 41673,
    Description: "Conventions (Sponsor's Risk Only)--Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/41673',
  },
  {
    Code: 41675,
    Description: 'Computer Consulting or Programming',
    URL: 'https://www.insurancexdate.com/gl/41675',
  },
  {
    Code: 41677,
    Description: 'Consultants',
    URL: 'https://www.insurancexdate.com/gl/41677',
  },
  {
    Code: 41678,
    Description: 'Community Recreational Facilities--Not Operated by Governmental Agency',
    URL: 'https://www.insurancexdate.com/gl/41678',
  },
  {
    Code: 41679,
    Description: 'Cotton Gin Operations--Other Than Those Performed for a Fee Per Bale',
    URL: 'https://www.insurancexdate.com/gl/41679',
  },
  {
    Code: 41680,
    Description: 'Convents or Monasteries',
    URL: 'https://www.insurancexdate.com/gl/41680',
  },
  {
    Code: 41696,
    Description: 'Crematories--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/41696',
  },
  {
    Code: 41697,
    Description: 'Crematories--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/41697',
  },
  {
    Code: 41700,
    Description: 'Dam, Levee or Dike--Existence Hazard Only',
    URL: 'https://www.insurancexdate.com/gl/41700',
  },
  {
    Code: 41715,
    Description: 'Day Care Centers--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/41715',
  },
  {
    Code: 41716,
    Description: 'Camps--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/41716',
  },
  {
    Code: 43007,
    Description: 'Drawbridges--Existence Hazard Only',
    URL: 'https://www.insurancexdate.com/gl/43007',
  },
  {
    Code: 43117,
    Description: 'Dude Ranches',
    URL: 'https://www.insurancexdate.com/gl/43117',
  },
  {
    Code: 43151,
    Description: 'Computer Data Processing--Operations',
    URL: 'https://www.insurancexdate.com/gl/43151',
  },
  {
    Code: 43152,
    Description: 'Computer Data Processing--Time Sharing',
    URL: 'https://www.insurancexdate.com/gl/43152',
  },
  {
    Code: 43200,
    Description: 'Employment Agencies',
    URL: 'https://www.insurancexdate.com/gl/43200',
  },
  {
    Code: 43215,
    Description: "Entertainment Performed on Others' Premises",
    URL: 'https://www.insurancexdate.com/gl/43215',
  },
  {
    Code: 43421,
    Description:
      'Exhibitions--Outside--In Stadiums or on Premises Having Grandstands or Bleachers Not Erected by or for Insured--Ushers or Other Attendants in Stands Not Provided by Insured',
    URL: 'https://www.insurancexdate.com/gl/43421',
  },
  {
    Code: 43422,
    Description:
      'Exhibitions--Outside--In Stadiums or on Premises Having Grandstands or Bleachers Not Erected by or for the Insured--Ushers or Other Attendants in Stands Provided by the Insured',
    URL: 'https://www.insurancexdate.com/gl/43422',
  },
  {
    Code: 43424,
    Description: 'Exhibitions--Outside--No Stadiums or Grandstands',
    URL: 'https://www.insurancexdate.com/gl/43424',
  },
  {
    Code: 43470,
    Description: 'Pest Control Services',
    URL: 'https://www.insurancexdate.com/gl/43470',
  },
  {
    Code: 43517,
    Description: 'Fair Grounds--Nonoperating Season',
    URL: 'https://www.insurancexdate.com/gl/43517',
  },
  {
    Code: 43518,
    Description: "Fairs--Outside (Operator's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/43518',
  },
  {
    Code: 43550,
    Description: 'Fire Departments--Other Than Volunteer',
    URL: 'https://www.insurancexdate.com/gl/43550',
  },
  {
    Code: 43551,
    Description: 'Fire Departments--Volunteer',
    URL: 'https://www.insurancexdate.com/gl/43551',
  },
  {
    Code: 43626,
    Description: "Fireworks Exhibitions--Contractor's Risk Only",
    URL: 'https://www.insurancexdate.com/gl/43626',
  },
  {
    Code: 43628,
    Description: "Fireworks Exhibitions--Sponsor's Risk Only--Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/43628',
  },
  {
    Code: 43629,
    Description: "Fireworks Exhibitions--Sponsor's Risk Only--Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/43629',
  },
  {
    Code: 43754,
    Description: 'Fishing Piers',
    URL: 'https://www.insurancexdate.com/gl/43754',
  },
  {
    Code: 43760,
    Description: 'Fishing Ponds or Lakes--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/43760',
  },
  {
    Code: 43822,
    Description: 'Forestry Service',
    URL: 'https://www.insurancexdate.com/gl/43822',
  },
  {
    Code: 43840,
    Description: 'Fruit or Vegetable--Harvesting Contractors',
    URL: 'https://www.insurancexdate.com/gl/43840',
  },
  {
    Code: 43860,
    Description: 'Fumigating',
    URL: 'https://www.insurancexdate.com/gl/43860',
  },
  {
    Code: 43889,
    Description: 'Funeral Homes or Chapels',
    URL: 'https://www.insurancexdate.com/gl/43889',
  },
  {
    Code: 43945,
    Description: 'Garbage or Refuse Dumps',
    URL: 'https://www.insurancexdate.com/gl/43945',
  },
  {
    Code: 43946,
    Description: 'Garbage Works--Separation for Recycling, Reduction or Incineration',
    URL: 'https://www.insurancexdate.com/gl/43946',
  },
  {
    Code: 43990,
    Description: 'Gambling--Casinos',
    URL: 'https://www.insurancexdate.com/gl/43990',
  },
  {
    Code: 43991,
    Description: 'Gambling--Incidental to Other Operations',
    URL: 'https://www.insurancexdate.com/gl/43991',
  },
  {
    Code: 44009,
    Description: "Gasoline or Oil Supply Stations--Retail--(Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/44009',
  },
  {
    Code: 44010,
    Description: 'Gasoline Recovery--from Casing Head or Natural Gas',
    URL: 'https://www.insurancexdate.com/gl/44010',
  },
  {
    Code: 44069,
    Description: 'Golf Courses--Miniature',
    URL: 'https://www.insurancexdate.com/gl/44069',
  },
  {
    Code: 44070,
    Description: 'Golf Courses--Municipal or Public--Not Golf or Country Clubs',
    URL: 'https://www.insurancexdate.com/gl/44070',
  },
  {
    Code: 44071,
    Description: 'Golf Driving Ranges',
    URL: 'https://www.insurancexdate.com/gl/44071',
  },
  {
    Code: 44072,
    Description: 'Golfmobiles--Loaned or Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/44072',
  },
  {
    Code: 44100,
    Description: 'Governmental: Municipalities--Population under 2,500',
    URL: 'https://www.insurancexdate.com/gl/44100',
  },
  {
    Code: 44101,
    Description: 'Governmental: Municipalities--Population 2,501-10,000',
    URL: 'https://www.insurancexdate.com/gl/44101',
  },
  {
    Code: 44102,
    Description: 'Governmental: Municipalities--Population 10,001-25,000',
    URL: 'https://www.insurancexdate.com/gl/44102',
  },
  {
    Code: 44103,
    Description: 'Governmental: Municipalities--Population 25,001-50,000',
    URL: 'https://www.insurancexdate.com/gl/44103',
  },
  {
    Code: 44104,
    Description: 'Governmental: Municipalities--Population 50,001-100,000',
    URL: 'https://www.insurancexdate.com/gl/44104',
  },
  {
    Code: 44105,
    Description: 'Governmental: Municipalities',
    URL: 'https://www.insurancexdate.com/gl/44105',
  },
  {
    Code: 44106,
    Description: 'Governmental: Municipalities--Population over 250,000',
    URL: 'https://www.insurancexdate.com/gl/44106',
  },
  {
    Code: 44108,
    Description: 'Governmental: Counties or Parishes--Population under 10,000',
    URL: 'https://www.insurancexdate.com/gl/44108',
  },
  {
    Code: 44109,
    Description: 'Governmental: Counties or Parishes--Population 10,001-25,000',
    URL: 'https://www.insurancexdate.com/gl/44109',
  },
  {
    Code: 44110,
    Description: 'Governmental: Counties or Parishes--Population 25,001-50,000',
    URL: 'https://www.insurancexdate.com/gl/44110',
  },
  {
    Code: 44111,
    Description: 'Governmental: Counties or Parishes--Population 50,001-100,000',
    URL: 'https://www.insurancexdate.com/gl/44111',
  },
  {
    Code: 44112,
    Description: 'Governmental: Counties or Parishes--Population 100,001-250,000',
    URL: 'https://www.insurancexdate.com/gl/44112',
  },
  {
    Code: 44113,
    Description: 'Governmental: Counties or Parishes--Population over 250,000',
    URL: 'https://www.insurancexdate.com/gl/44113',
  },
  {
    Code: 44193,
    Description: 'Grandstands or Bleachers--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44193',
  },
  {
    Code: 44194,
    Description: 'Grandstands or Bleachers--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44194',
  },
  {
    Code: 44222,
    Description: 'Guides or Outfitters',
    URL: 'https://www.insurancexdate.com/gl/44222',
  },
  {
    Code: 44276,
    Description: 'Halls--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44276',
  },
  {
    Code: 44277,
    Description: 'Halls--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44277',
  },
  {
    Code: 44280,
    Description: 'Event, Party or Wedding Planners',
    URL: 'https://www.insurancexdate.com/gl/44280',
  },
  {
    Code: 44311,
    Description: 'Health or Exercise Clubs',
    URL: 'https://www.insurancexdate.com/gl/44311',
  },
  {
    Code: 44315,
    Description: 'Health or Exercise Facilities--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/44315',
  },
  {
    Code: 44427,
    Description: 'Health Care Facilities--Alcohol and Drug--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44427',
  },
  {
    Code: 44428,
    Description: 'Health Care Facilities--Alcohol and Drug--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44428',
  },
  {
    Code: 44429,
    Description:
      'Health Care Facilities--Convalescent or Nursing Homes--Not Mental--Psychopathic Institutions--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44429',
  },
  {
    Code: 44430,
    Description:
      'Health Care Facilities--Convalescent or Nursing Homes--Not Mental--Psychopathic Institutions--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44430',
  },
  {
    Code: 44431,
    Description: 'Health Care Facilities--Homes for the Aged--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44431',
  },
  {
    Code: 44432,
    Description: 'Health Care Facilities--Homes for the Aged--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44432',
  },
  {
    Code: 44433,
    Description: 'Health Care Facilities--Homes for the Physically Handicapped or Orphaned--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44433',
  },
  {
    Code: 44434,
    Description: 'Health Care Facilities--Homes for the Physically Handicapped or Orphaned--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44434',
  },
  {
    Code: 44435,
    Description: 'Health Care Facilities--Hospitals Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44435',
  },
  {
    Code: 44436,
    Description: 'Health Care Facilities--Hospitals Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44436',
  },
  {
    Code: 44437,
    Description: 'Health Care Facilities--Mental--Psychopathic Institutions--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44437',
  },
  {
    Code: 44438,
    Description: 'Health Care Facilities--Mental--Psychopathic Institutions--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44438',
  },
  {
    Code: 44439,
    Description:
      'Health Care Facilities--Clinics, Dispensaries or Infirmaries Treating Outpatients Only--No Regular Bed and Board Facilities--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44439',
  },
  {
    Code: 44440,
    Description:
      'Health Care Facilities--Clinics, Dispensaries or Infirmaries Treating Outpatients Only--No Regular Bed and Board Facilities--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44440',
  },
  {
    Code: 44500,
    Description: 'Home Health Care Services--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/44500',
  },
  {
    Code: 44501,
    Description: 'Home Health Care Services--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/44501',
  },
  {
    Code: 45190,
    Description: 'Hotels and Motels--with Pools or Beaches--Less Than Four Stories',
    URL: 'https://www.insurancexdate.com/gl/45190',
  },
  {
    Code: 45191,
    Description: 'Hotels and Motels--with Pools or Beaches--Four Stories or More',
    URL: 'https://www.insurancexdate.com/gl/45191',
  },
  {
    Code: 45192,
    Description: 'Hotels and Motels--without Pools or Beaches--Less Than Four Stories',
    URL: 'https://www.insurancexdate.com/gl/45192',
  },
  {
    Code: 45193,
    Description: 'Hotels and Motels--without Pools or Beaches--Four Stories or More',
    URL: 'https://www.insurancexdate.com/gl/45193',
  },
  {
    Code: 45210,
    Description: 'Bed and Breakfasts',
    URL: 'https://www.insurancexdate.com/gl/45210',
  },
  {
    Code: 45224,
    Description: 'Hunting Preserves--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/45224',
  },
  {
    Code: 45225,
    Description: 'Hunting Preserves--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/45225',
  },
  {
    Code: 45334,
    Description: 'Insurance Agents',
    URL: 'https://www.insurancexdate.com/gl/45334',
  },
  {
    Code: 45380,
    Description: 'Junk Dealers',
    URL: 'https://www.insurancexdate.com/gl/45380',
  },
  {
    Code: 45450,
    Description: 'Kennels--Breeding, Boarding or Sales',
    URL: 'https://www.insurancexdate.com/gl/45450',
  },
  {
    Code: 45523,
    Description: 'Lakes or Reservoirs--Existence Hazard Only--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/45523',
  },
  {
    Code: 45524,
    Description: 'Lakes or Reservoirs--Existence Hazard Only--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/45524',
  },
  {
    Code: 45539,
    Description: "Land--Occupied by Persons Other Than the Insured for Business Purposes--(Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/45539',
  },
  {
    Code: 45678,
    Description: 'Laundries and Dry Cleaning Plants',
    URL: 'https://www.insurancexdate.com/gl/45678',
  },
  {
    Code: 45771,
    Description: 'Livestock Sales Companies',
    URL: 'https://www.insurancexdate.com/gl/45771',
  },
  {
    Code: 45819,
    Description: 'Lumberyards',
    URL: 'https://www.insurancexdate.com/gl/45819',
  },
  {
    Code: 45900,
    Description: 'Mail Order or Online Drug Stores',
    URL: 'https://www.insurancexdate.com/gl/45900',
  },
  {
    Code: 45901,
    Description: 'Mail Order Houses',
    URL: 'https://www.insurancexdate.com/gl/45901',
  },
  {
    Code: 45937,
    Description: 'Mailing or Addressing Companies',
    URL: 'https://www.insurancexdate.com/gl/45937',
  },
  {
    Code: 45993,
    Description: "Manufacturers' Representatives",
    URL: 'https://www.insurancexdate.com/gl/45993',
  },
  {
    Code: 46004,
    Description: 'Mausoleums--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/46004',
  },
  {
    Code: 46005,
    Description: 'Mausoleums--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/46005',
  },
  {
    Code: 46112,
    Description: 'Diagnostic Testing Laboratories',
    URL: 'https://www.insurancexdate.com/gl/46112',
  },
  {
    Code: 46202,
    Description: 'Mobile Home Parks or Courts',
    URL: 'https://www.insurancexdate.com/gl/46202',
  },
  {
    Code: 46362,
    Description: 'Model Homes',
    URL: 'https://www.insurancexdate.com/gl/46362',
  },
  {
    Code: 46426,
    Description: 'Museums--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/46426',
  },
  {
    Code: 46427,
    Description: 'Museums--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/46427',
  },
  {
    Code: 46510,
    Description: 'Oil or Gas Wells--Non-Operating Working Interest',
    URL: 'https://www.insurancexdate.com/gl/46510',
  },
  {
    Code: 46590,
    Description: 'Parades',
    URL: 'https://www.insurancexdate.com/gl/46590',
  },
  {
    Code: 46603,
    Description: 'Parking--Public--Not Open Air',
    URL: 'https://www.insurancexdate.com/gl/46603',
  },
  {
    Code: 46604,
    Description: 'Parking--Public--Open Air',
    URL: 'https://www.insurancexdate.com/gl/46604',
  },
  {
    Code: 46606,
    Description: "Parking--Public--Shopping Centers--Maintained by Lessee (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/46606',
  },
  {
    Code: 46607,
    Description: "Parking--Public--Shopping Centers--Maintained by the Insured (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/46607',
  },
  {
    Code: 46622,
    Description: 'Parking--Private',
    URL: 'https://www.insurancexdate.com/gl/46622',
  },
  {
    Code: 46671,
    Description: 'Parks or Playgrounds',
    URL: 'https://www.insurancexdate.com/gl/46671',
  },
  {
    Code: 46700,
    Description: 'Penal Institutions',
    URL: 'https://www.insurancexdate.com/gl/46700',
  },
  {
    Code: 46773,
    Description: 'Picnic Grounds--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/46773',
  },
  {
    Code: 46822,
    Description: 'Political Campaign Headquarters or Offices',
    URL: 'https://www.insurancexdate.com/gl/46822',
  },
  {
    Code: 46881,
    Description:
      'Professional and Trade Associations--No Buildings or Premises Owned or Leased Except as Offices--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/46881',
  },
  {
    Code: 46882,
    Description:
      'Professional and Trade Associations--No Buildings or Premises Owned or Leased Except as Offices--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/46882',
  },
  {
    Code: 46911,
    Description: 'Race Tracks--Motorized Vehicles--Operators',
    URL: 'https://www.insurancexdate.com/gl/46911',
  },
  {
    Code: 46912,
    Description: 'Race Tracks--Operators',
    URL: 'https://www.insurancexdate.com/gl/46912',
  },
  {
    Code: 46913,
    Description: "Race Tracks--Motorized Vehicles--Lessor's Risk Only",
    URL: 'https://www.insurancexdate.com/gl/46913',
  },
  {
    Code: 46914,
    Description: "Racing--Lessor's Risk Only",
    URL: 'https://www.insurancexdate.com/gl/46914',
  },
  {
    Code: 46915,
    Description: "Race Tracks--Motorized Vehicles--Sponsor's Risk Only",
    URL: 'https://www.insurancexdate.com/gl/46915',
  },
  {
    Code: 46916,
    Description: "Racing--Sponsor's Risk Only",
    URL: 'https://www.insurancexdate.com/gl/46916',
  },
  {
    Code: 47050,
    Description: 'Real Estate Agents',
    URL: 'https://www.insurancexdate.com/gl/47050',
  },
  {
    Code: 47051,
    Description: 'Real Estate Development Property',
    URL: 'https://www.insurancexdate.com/gl/47051',
  },
  {
    Code: 47052,
    Description: 'Real Estate Property Managed',
    URL: 'https://www.insurancexdate.com/gl/47052',
  },
  {
    Code: 47103,
    Description: 'Recording Studios',
    URL: 'https://www.insurancexdate.com/gl/47103',
  },
  {
    Code: 47146,
    Description: 'Recycling Collection Centers--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/47146',
  },
  {
    Code: 47147,
    Description: 'Recycling Collection Centers--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/47147',
  },
  {
    Code: 47221,
    Description: 'Riding Academies',
    URL: 'https://www.insurancexdate.com/gl/47221',
  },
  {
    Code: 47253,
    Description: 'Rifle or Pistol Ranges--Indoor',
    URL: 'https://www.insurancexdate.com/gl/47253',
  },
  {
    Code: 47254,
    Description: 'Rifle or Pistol Ranges',
    URL: 'https://www.insurancexdate.com/gl/47254',
  },
  {
    Code: 47318,
    Description: 'Rodeos',
    URL: 'https://www.insurancexdate.com/gl/47318',
  },
  {
    Code: 47367,
    Description: 'Sales or Service Organizations',
    URL: 'https://www.insurancexdate.com/gl/47367',
  },
  {
    Code: 47420,
    Description: 'Saunas and Baths--Public',
    URL: 'https://www.insurancexdate.com/gl/47420',
  },
  {
    Code: 47468,
    Description: 'Schools--Correspondence',
    URL: 'https://www.insurancexdate.com/gl/47468',
  },
  {
    Code: 47469,
    Description: 'Schools--Faculty Liability for Corporal Punishment of Students',
    URL: 'https://www.insurancexdate.com/gl/47469',
  },
  {
    Code: 47471,
    Description: 'Schools--Public--Elementary, Kindergarten or Junior High',
    URL: 'https://www.insurancexdate.com/gl/47471',
  },
  {
    Code: 47473,
    Description: 'Schools--Public--High',
    URL: 'https://www.insurancexdate.com/gl/47473',
  },
  {
    Code: 47474,
    Description: 'Schools--Trade or Vocational',
    URL: 'https://www.insurancexdate.com/gl/47474',
  },
  {
    Code: 47475,
    Description: 'Schools--Private--Elementary, Kindergarten or Junior High--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/47475',
  },
  {
    Code: 47476,
    Description: 'Schools--Private--Elementary, Kindergarten or Junior High--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/47476',
  },
  {
    Code: 47477,
    Description: 'Schools--Private--High--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/47477',
  },
  {
    Code: 47478,
    Description: 'Schools--Private--High--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/47478',
  },
  {
    Code: 47610,
    Description: 'Internet Service Providers',
    URL: 'https://www.insurancexdate.com/gl/47610',
  },
  {
    Code: 48039,
    Description: 'Sewers',
    URL: 'https://www.insurancexdate.com/gl/48039',
  },
  {
    Code: 48177,
    Description: 'Skating Rinks--Ice',
    URL: 'https://www.insurancexdate.com/gl/48177',
  },
  {
    Code: 48178,
    Description: 'Skating Rinks--Roller',
    URL: 'https://www.insurancexdate.com/gl/48178',
  },
  {
    Code: 48206,
    Description: 'Skeet Shooting or Trap Shooting Ranges',
    URL: 'https://www.insurancexdate.com/gl/48206',
  },
  {
    Code: 48252,
    Description: 'Ski Lifts, Tows or Runs',
    URL: 'https://www.insurancexdate.com/gl/48252',
  },
  {
    Code: 48441,
    Description: 'Soap Box Derbies',
    URL: 'https://www.insurancexdate.com/gl/48441',
  },
  {
    Code: 48557,
    Description:
      'Social Gatherings and Meetings--on Premises Not Owned or Operated by the Insured--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/48557',
  },
  {
    Code: 48558,
    Description:
      'Social Gatherings and Meetings--on Premises Not Owned or Operated by the Insured--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/48558',
  },
  {
    Code: 48600,
    Description: 'Social Services--Consulting Services Only--Operated by the Private Sector',
    URL: 'https://www.insurancexdate.com/gl/48600',
  },
  {
    Code: 48610,
    Description: 'Sports or Outdoor Activities--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/48610',
  },
  {
    Code: 48636,
    Description: 'Stockyards',
    URL: 'https://www.insurancexdate.com/gl/48636',
  },
  {
    Code: 48637,
    Description: 'Stadiums--Operated by Insured--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/48637',
  },
  {
    Code: 48638,
    Description: 'Stadiums--Operated by Insured--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/48638',
  },
  {
    Code: 48727,
    Description: 'Streets, Roads, Highways or Bridges--Existence and Maintenance Hazard Only',
    URL: 'https://www.insurancexdate.com/gl/48727',
  },
  {
    Code: 48808,
    Description: 'Sun Tanning Salons',
    URL: 'https://www.insurancexdate.com/gl/48808',
  },
  {
    Code: 48924,
    Description: 'Swimming Pools--Commercially Operated',
    URL: 'https://www.insurancexdate.com/gl/48924',
  },
  {
    Code: 48925,
    Description: 'Swimming Pools',
    URL: 'https://www.insurancexdate.com/gl/48925',
  },
  {
    Code: 49005,
    Description: 'Taxidermists',
    URL: 'https://www.insurancexdate.com/gl/49005',
  },
  {
    Code: 49111,
    Description: 'Tents or Canopies--Loaned or Rented to Others',
    URL: 'https://www.insurancexdate.com/gl/49111',
  },
  {
    Code: 49181,
    Description: 'Theaters--Drive-In',
    URL: 'https://www.insurancexdate.com/gl/49181',
  },
  {
    Code: 49183,
    Description: 'Theaters--Motion Pictures',
    URL: 'https://www.insurancexdate.com/gl/49183',
  },
  {
    Code: 49184,
    Description: 'Theaters--Other Than Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/49184',
  },
  {
    Code: 49185,
    Description: 'Theaters--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/49185',
  },
  {
    Code: 49239,
    Description: 'Tire--Retreading or Recapping',
    URL: 'https://www.insurancexdate.com/gl/49239',
  },
  {
    Code: 49292,
    Description: 'Toll Bridges',
    URL: 'https://www.insurancexdate.com/gl/49292',
  },
  {
    Code: 49305,
    Description: 'Towers--Telecommunication--Existence Hazard Only (Lessors Risk Only)',
    URL: 'https://www.insurancexdate.com/gl/49305',
  },
  {
    Code: 49333,
    Description: 'Travel Agency Tours',
    URL: 'https://www.insurancexdate.com/gl/49333',
  },
  {
    Code: 49451,
    Description: 'Vacant Land--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/49451',
  },
  {
    Code: 49452,
    Description: 'Vacant Land--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/49452',
  },
  {
    Code: 49617,
    Description: 'Vending Machine Operations--Confection, Food, Beverage or Ice',
    URL: 'https://www.insurancexdate.com/gl/49617',
  },
  {
    Code: 49618,
    Description: 'Vending Machine Operations--Tobacco Products',
    URL: 'https://www.insurancexdate.com/gl/49618',
  },
  {
    Code: 49619,
    Description: 'Vending Machine Operations',
    URL: 'https://www.insurancexdate.com/gl/49619',
  },
  {
    Code: 49763,
    Description: 'Warehouse--Cold Individual Storage Lockers',
    URL: 'https://www.insurancexdate.com/gl/49763',
  },
  {
    Code: 49800,
    Description: 'Wharf and Waterfront Property--Ferry Docks or Terminals',
    URL: 'https://www.insurancexdate.com/gl/49800',
  },
  {
    Code: 49801,
    Description: 'Wharf and Waterfront Property--Occupied by the Insured for Both Freight and Passenger Purposes',
    URL: 'https://www.insurancexdate.com/gl/49801',
  },
  {
    Code: 49802,
    Description: "Wharf and Waterfront Property--Not Occupied by the Insured (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/49802',
  },
  {
    Code: 49803,
    Description: 'Wharf and Waterfront Property--Occupied by the Insured for Freight Purposes Exclusively',
    URL: 'https://www.insurancexdate.com/gl/49803',
  },
  {
    Code: 49840,
    Description: 'Window Decorating',
    URL: 'https://www.insurancexdate.com/gl/49840',
  },
  {
    Code: 49870,
    Description: 'YMCA, YWCA or Similar Institutions',
    URL: 'https://www.insurancexdate.com/gl/49870',
  },
  {
    Code: 49890,
    Description: 'Youth Recreation Programs--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/49890',
  },
  {
    Code: 49891,
    Description: 'Youth Recreation Programs--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/49891',
  },
  {
    Code: 49902,
    Description: 'Zoos--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/49902',
  },
  {
    Code: 49903,
    Description: 'Zoos--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/49903',
  },
  {
    Code: 50010,
    Description: 'Abrasive Wheel Mfg.',
    URL: 'https://www.insurancexdate.com/gl/50010',
  },
  {
    Code: 50015,
    Description: 'Abrasives or Abrasive Products Mfg.--Artificial',
    URL: 'https://www.insurancexdate.com/gl/50015',
  },
  {
    Code: 50017,
    Description: 'Abrasives or Abrasive Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/50017',
  },
  {
    Code: 50045,
    Description: 'Adhesive Mfg.',
    URL: 'https://www.insurancexdate.com/gl/50045',
  },
  {
    Code: 50047,
    Description: 'Adhesive Tape Mfg.',
    URL: 'https://www.insurancexdate.com/gl/50047',
  },
  {
    Code: 51001,
    Description: 'Aerosol Container Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51001',
  },
  {
    Code: 51005,
    Description: 'Aerosol Containers--Filling or Charging for Others',
    URL: 'https://www.insurancexdate.com/gl/51005',
  },
  {
    Code: 51116,
    Description: 'Air Conditioning Equipment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51116',
  },
  {
    Code: 51201,
    Description: 'Aircraft or Aircraft Parts Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51201',
  },
  {
    Code: 51205,
    Description: 'Alarm Mfg.--Burglar',
    URL: 'https://www.insurancexdate.com/gl/51205',
  },
  {
    Code: 51206,
    Description: 'Alarm Mfg.--Fire or Smoke',
    URL: 'https://www.insurancexdate.com/gl/51206',
  },
  {
    Code: 51210,
    Description: 'Alcohol Mfg.--Not Beverage',
    URL: 'https://www.insurancexdate.com/gl/51210',
  },
  {
    Code: 51211,
    Description: 'Ammunition Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51211',
  },
  {
    Code: 51220,
    Description: 'Appliances and Accessories Mfg.--Commercial--Gas',
    URL: 'https://www.insurancexdate.com/gl/51220',
  },
  {
    Code: 51221,
    Description: 'Appliances and Accessories Mfg.--Commercial--Not Gas',
    URL: 'https://www.insurancexdate.com/gl/51221',
  },
  {
    Code: 51222,
    Description: 'Appliances and Accessories Mfg.--Household--Gas',
    URL: 'https://www.insurancexdate.com/gl/51222',
  },
  {
    Code: 51224,
    Description: 'Appliances and Accessories Mfg.--Household--Not Gas',
    URL: 'https://www.insurancexdate.com/gl/51224',
  },
  {
    Code: 51230,
    Description: 'Asbestos Goods Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51230',
  },
  {
    Code: 51240,
    Description: 'Asphalt or Tar Distilling or Refining',
    URL: 'https://www.insurancexdate.com/gl/51240',
  },
  {
    Code: 51241,
    Description: 'Asphalt Works',
    URL: 'https://www.insurancexdate.com/gl/51241',
  },
  {
    Code: 51250,
    Description: 'Automobile, Bus and Truck Body Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51250',
  },
  {
    Code: 51251,
    Description: 'Automobile, Bus or Truck Parts Mfg.--Brakes or Brake Linings',
    URL: 'https://www.insurancexdate.com/gl/51251',
  },
  {
    Code: 51252,
    Description: 'Automobile, Bus or Truck Parts Mfg.--Not Operating Parts',
    URL: 'https://www.insurancexdate.com/gl/51252',
  },
  {
    Code: 51253,
    Description: 'Automobile, Bus or Truck Parts Mfg.--Operating Parts',
    URL: 'https://www.insurancexdate.com/gl/51253',
  },
  {
    Code: 51254,
    Description: 'Automobile, Bus or Truck Parts Mfg.--Passenger Restraining Devices',
    URL: 'https://www.insurancexdate.com/gl/51254',
  },
  {
    Code: 51255,
    Description: 'Automobile Mfg. or Assembling',
    URL: 'https://www.insurancexdate.com/gl/51255',
  },
  {
    Code: 51305,
    Description: 'Baby Food Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51305',
  },
  {
    Code: 51315,
    Description: 'Bakery Plants',
    URL: 'https://www.insurancexdate.com/gl/51315',
  },
  {
    Code: 51330,
    Description: 'Battery Mfg.--Dry Cell',
    URL: 'https://www.insurancexdate.com/gl/51330',
  },
  {
    Code: 51333,
    Description: 'Battery Mfg.--Wet Cell or Storage',
    URL: 'https://www.insurancexdate.com/gl/51333',
  },
  {
    Code: 51340,
    Description: 'Bearing Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51340',
  },
  {
    Code: 51350,
    Description: 'Beer, Ale or Malt Liquor Mfg.--In Bottles',
    URL: 'https://www.insurancexdate.com/gl/51350',
  },
  {
    Code: 51351,
    Description: 'Beer, Ale or Malt Liquor Mfg.--In Cans',
    URL: 'https://www.insurancexdate.com/gl/51351',
  },
  {
    Code: 51352,
    Description: 'Beer, Ale or Malt Liquor Mfg.--Not Bottled or Canned',
    URL: 'https://www.insurancexdate.com/gl/51352',
  },
  {
    Code: 51355,
    Description: 'Beverage Bottler--Soft Drinks--Carbonated--In Cans or Plastic Bottles',
    URL: 'https://www.insurancexdate.com/gl/51355',
  },
  {
    Code: 51356,
    Description: 'Beverage Bottler--Soft Drinks--Carbonated--In Glass Bottles',
    URL: 'https://www.insurancexdate.com/gl/51356',
  },
  {
    Code: 51357,
    Description: 'Beverage Bottler--Soft Drinks--In Metal Cylinders',
    URL: 'https://www.insurancexdate.com/gl/51357',
  },
  {
    Code: 51358,
    Description: 'Beverage Bottler--Soft Drinks--In Paper Containers',
    URL: 'https://www.insurancexdate.com/gl/51358',
  },
  {
    Code: 51359,
    Description: 'Beverage Bottler--Soft Drinks--Not Carbonated--In Bottles or Cans',
    URL: 'https://www.insurancexdate.com/gl/51359',
  },
  {
    Code: 51370,
    Description: 'Bicycle Mfg.--Not Motorized',
    URL: 'https://www.insurancexdate.com/gl/51370',
  },
  {
    Code: 51380,
    Description: 'Billiard or Pool Table Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51380',
  },
  {
    Code: 51400,
    Description: 'Boat or Ship Building--Inboard and Inboard/Outboard',
    URL: 'https://www.insurancexdate.com/gl/51400',
  },
  {
    Code: 51401,
    Description: 'Boat or Ship Building--without Motors',
    URL: 'https://www.insurancexdate.com/gl/51401',
  },
  {
    Code: 51500,
    Description: 'Bolt, Nut, Rivet, Screw or Washer Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51500',
  },
  {
    Code: 51516,
    Description: 'Bookbinding--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/51516',
  },
  {
    Code: 51517,
    Description: 'Bookbinding--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/51517',
  },
  {
    Code: 51550,
    Description: 'Bottle and Jar Mfg.--Glass--Not for Use under Pressure',
    URL: 'https://www.insurancexdate.com/gl/51550',
  },
  {
    Code: 51551,
    Description: 'Bottle and Jar Mfg.--Glass--for Use under Pressure--Nonreturnable',
    URL: 'https://www.insurancexdate.com/gl/51551',
  },
  {
    Code: 51552,
    Description: 'Bottle and Jar Mfg.--Glass--for Use under Pressure--Returnable',
    URL: 'https://www.insurancexdate.com/gl/51552',
  },
  {
    Code: 51553,
    Description: 'Bottle and Jar Mfg.--Plastic--Nonreturnable',
    URL: 'https://www.insurancexdate.com/gl/51553',
  },
  {
    Code: 51554,
    Description: 'Bottle and Jar Mfg.--Plastic--Returnable',
    URL: 'https://www.insurancexdate.com/gl/51554',
  },
  {
    Code: 51575,
    Description: 'Boxes or Containers Mfg.--Corrugated or Fiberboard',
    URL: 'https://www.insurancexdate.com/gl/51575',
  },
  {
    Code: 51576,
    Description: 'Boxes or Containers Mfg.--Wood',
    URL: 'https://www.insurancexdate.com/gl/51576',
  },
  {
    Code: 51600,
    Description: 'Brick Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51600',
  },
  {
    Code: 51613,
    Description: 'Brush or Broom Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51613',
  },
  {
    Code: 51625,
    Description: 'Bus Mfg. or Assembling or Reconstruction',
    URL: 'https://www.insurancexdate.com/gl/51625',
  },
  {
    Code: 51666,
    Description: 'Buttons or Fasteners Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51666',
  },
  {
    Code: 51702,
    Description: 'Camper Bodies or Camper Trailers Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51702',
  },
  {
    Code: 51703,
    Description: 'Campers Mfg.--Self-Powered',
    URL: 'https://www.insurancexdate.com/gl/51703',
  },
  {
    Code: 51734,
    Description: 'Can Mfg.--Metal',
    URL: 'https://www.insurancexdate.com/gl/51734',
  },
  {
    Code: 51741,
    Description: 'Candle Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51741',
  },
  {
    Code: 51752,
    Description: 'Candy or Confectionery Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51752',
  },
  {
    Code: 51767,
    Description: 'Carbon Paper or Inked Ribbon Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51767',
  },
  {
    Code: 51777,
    Description: 'Carpet or Rug Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51777',
  },
  {
    Code: 51790,
    Description: 'Caulking Compounds, Putty or Similar Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51790',
  },
  {
    Code: 51796,
    Description: 'Cellophane and Cellophane Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51796',
  },
  {
    Code: 51808,
    Description: 'Cement, Concrete Mix or Plaster Mfg.--Packaged',
    URL: 'https://www.insurancexdate.com/gl/51808',
  },
  {
    Code: 51809,
    Description: 'Cement or Plaster Mfg.--Bulk',
    URL: 'https://www.insurancexdate.com/gl/51809',
  },
  {
    Code: 51833,
    Description: 'Charcoal or Coal Briquette Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51833',
  },
  {
    Code: 51850,
    Description: 'Chemical Mfg.--Commercial or Industrial',
    URL: 'https://www.insurancexdate.com/gl/51850',
  },
  {
    Code: 51851,
    Description: 'Chemical Mfg.--Commercial or Industrial--Toxic and Either Flammable, Explosive or Reactive',
    URL: 'https://www.insurancexdate.com/gl/51851',
  },
  {
    Code: 51852,
    Description: 'Chemical Mfg.--Commercial or Industrial--Primarily Flammable, Explosive or Reactive',
    URL: 'https://www.insurancexdate.com/gl/51852',
  },
  {
    Code: 51853,
    Description: 'Chemical Mfg.--Commercial or Industrial--Primarily Toxic or Presenting a Health Hazard',
    URL: 'https://www.insurancexdate.com/gl/51853',
  },
  {
    Code: 51854,
    Description: 'Chemical Mfg.--Household--Toxic and Either Flammable, Explosive or Reactive',
    URL: 'https://www.insurancexdate.com/gl/51854',
  },
  {
    Code: 51855,
    Description: 'Chemical Mfg.--Household',
    URL: 'https://www.insurancexdate.com/gl/51855',
  },
  {
    Code: 51856,
    Description: 'Chemical Mfg.--Household--Primarily Flammable, Explosive or Reactive',
    URL: 'https://www.insurancexdate.com/gl/51856',
  },
  {
    Code: 51857,
    Description: 'Chemical Mfg.--Household--Primarily Toxic or Presenting a Health Hazard',
    URL: 'https://www.insurancexdate.com/gl/51857',
  },
  {
    Code: 51869,
    Description: 'China, Porcelain or Earthenware Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51869',
  },
  {
    Code: 51877,
    Description: 'Clay Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51877',
  },
  {
    Code: 51889,
    Description: 'Clock Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51889',
  },
  {
    Code: 51896,
    Description: 'Clothing Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51896',
  },
  {
    Code: 51900,
    Description: 'Coffins or Caskets Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51900',
  },
  {
    Code: 51909,
    Description: 'Coke Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51909',
  },
  {
    Code: 51919,
    Description: 'Color or Pigment Preparation',
    URL: 'https://www.insurancexdate.com/gl/51919',
  },
  {
    Code: 51926,
    Description: 'Communication or Recording Systems or Equipment Mfg.--Industrial or Commercial',
    URL: 'https://www.insurancexdate.com/gl/51926',
  },
  {
    Code: 51927,
    Description: 'Communication or Recording Systems or Equipment Mfg.--Other Than Industrial or Commercial',
    URL: 'https://www.insurancexdate.com/gl/51927',
  },
  {
    Code: 51934,
    Description: 'Composition Goods Mfg.--Not Floor Coverings',
    URL: 'https://www.insurancexdate.com/gl/51934',
  },
  {
    Code: 51941,
    Description: 'Computer Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51941',
  },
  {
    Code: 51942,
    Description: 'Computer Software Mfg.--Pre-Packaged',
    URL: 'https://www.insurancexdate.com/gl/51942',
  },
  {
    Code: 51956,
    Description: 'Concrete--Mixed in Transit',
    URL: 'https://www.insurancexdate.com/gl/51956',
  },
  {
    Code: 51957,
    Description: 'Concrete or Plaster Products Mfg.--Not Structural',
    URL: 'https://www.insurancexdate.com/gl/51957',
  },
  {
    Code: 51958,
    Description: 'Concrete Products Mfg.--Prestressed',
    URL: 'https://www.insurancexdate.com/gl/51958',
  },
  {
    Code: 51959,
    Description: 'Concrete Products Mfg.--Structural',
    URL: 'https://www.insurancexdate.com/gl/51959',
  },
  {
    Code: 51960,
    Description: 'Contact Lenses Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51960',
  },
  {
    Code: 51970,
    Description: 'Cosmetics Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51970',
  },
  {
    Code: 51982,
    Description: 'Cotton Batting, Wadding or Waste Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51982',
  },
  {
    Code: 51985,
    Description: 'Cotton Compressing',
    URL: 'https://www.insurancexdate.com/gl/51985',
  },
  {
    Code: 51986,
    Description: 'Cotton Gin Operations',
    URL: 'https://www.insurancexdate.com/gl/51986',
  },
  {
    Code: 51999,
    Description: 'Cutlery (Not Powered) and Flatware Mfg.',
    URL: 'https://www.insurancexdate.com/gl/51999',
  },
  {
    Code: 52002,
    Description: 'Dairy Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52002',
  },
  {
    Code: 52075,
    Description: 'Detergent Mfg.--Household',
    URL: 'https://www.insurancexdate.com/gl/52075',
  },
  {
    Code: 52076,
    Description: 'Detergent Mfg.--Other Than Household',
    URL: 'https://www.insurancexdate.com/gl/52076',
  },
  {
    Code: 52109,
    Description: 'Dextrine Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52109',
  },
  {
    Code: 52134,
    Description: 'Door or Window Mfg.--Other Than Wood',
    URL: 'https://www.insurancexdate.com/gl/52134',
  },
  {
    Code: 52137,
    Description: 'Die Casting Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52137',
  },
  {
    Code: 52150,
    Description: 'Distillation or Extraction',
    URL: 'https://www.insurancexdate.com/gl/52150',
  },
  {
    Code: 52315,
    Description: 'Door or Window Mfg.--Wood',
    URL: 'https://www.insurancexdate.com/gl/52315',
  },
  {
    Code: 52341,
    Description: 'Drug Mfg.--Biological Products',
    URL: 'https://www.insurancexdate.com/gl/52341',
  },
  {
    Code: 52342,
    Description: 'Drug, Medicine or Pharmaceutical Preparations Mfg.--for Animal Use',
    URL: 'https://www.insurancexdate.com/gl/52342',
  },
  {
    Code: 52343,
    Description: 'Drug, Medicine or Pharmaceutical Preparations Mfg.--Other Than for Animal Use',
    URL: 'https://www.insurancexdate.com/gl/52343',
  },
  {
    Code: 52401,
    Description: 'Drums or Containers Mfg.--Metal',
    URL: 'https://www.insurancexdate.com/gl/52401',
  },
  {
    Code: 52402,
    Description: 'Drums or Containers Mfg.--Plastic',
    URL: 'https://www.insurancexdate.com/gl/52402',
  },
  {
    Code: 52432,
    Description: 'Electrical Equipment Mfg.--Other Than for Direct and Indirect Application to the Body',
    URL: 'https://www.insurancexdate.com/gl/52432',
  },
  {
    Code: 52433,
    Description: 'Electrical Equipment Mfg.--for Direct and Indirect Application to the Body',
    URL: 'https://www.insurancexdate.com/gl/52433',
  },
  {
    Code: 52435,
    Description: 'Electrical Generating Machinery Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52435',
  },
  {
    Code: 52438,
    Description: 'Electrical Parts, Components or Accessories Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52438',
  },
  {
    Code: 52440,
    Description: 'Electrical Power Distribution or Transmission Equipment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52440',
  },
  {
    Code: 52467,
    Description: 'Electrical Wire or Cable Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52467',
  },
  {
    Code: 52469,
    Description: 'Electronic Components Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52469',
  },
  {
    Code: 52505,
    Description: 'Electronic Games Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52505',
  },
  {
    Code: 52547,
    Description: 'Electroplating',
    URL: 'https://www.insurancexdate.com/gl/52547',
  },
  {
    Code: 52581,
    Description: 'Elevator Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52581',
  },
  {
    Code: 52619,
    Description: 'Engine or Turbine Mfg.--Not Aircraft',
    URL: 'https://www.insurancexdate.com/gl/52619',
  },
  {
    Code: 52660,
    Description: 'Engraving',
    URL: 'https://www.insurancexdate.com/gl/52660',
  },
  {
    Code: 52744,
    Description: 'Escalator or Moving Sidewalk Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52744',
  },
  {
    Code: 52767,
    Description: 'Exercise or Playground Equipment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52767',
  },
  {
    Code: 52876,
    Description: 'Explosive or Fireworks Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52876',
  },
  {
    Code: 52911,
    Description: 'Extracts Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52911',
  },
  {
    Code: 52967,
    Description: 'Eye Glass Lens Mfg.',
    URL: 'https://www.insurancexdate.com/gl/52967',
  },
  {
    Code: 53001,
    Description: 'Feed Mfg.',
    URL: 'https://www.insurancexdate.com/gl/53001',
  },
  {
    Code: 53077,
    Description: 'Fertilizer Mfg.',
    URL: 'https://www.insurancexdate.com/gl/53077',
  },
  {
    Code: 53095,
    Description: 'Fiber Mfg.--Other Than Synthetic',
    URL: 'https://www.insurancexdate.com/gl/53095',
  },
  {
    Code: 53096,
    Description: 'Fiber Mfg.--Synthetic',
    URL: 'https://www.insurancexdate.com/gl/53096',
  },
  {
    Code: 53121,
    Description: 'Fiberglass Mfg.',
    URL: 'https://www.insurancexdate.com/gl/53121',
  },
  {
    Code: 53147,
    Description: 'Fire Extinguishers Mfg.',
    URL: 'https://www.insurancexdate.com/gl/53147',
  },
  {
    Code: 53229,
    Description: 'Fire Suppression Systems Mfg.',
    URL: 'https://www.insurancexdate.com/gl/53229',
  },
  {
    Code: 53271,
    Description: 'Firearms Mfg.',
    URL: 'https://www.insurancexdate.com/gl/53271',
  },
  {
    Code: 53333,
    Description: 'Floor Covering Mfg.--Not Carpets, Rugs, Ceramic or Stone Tiles',
    URL: 'https://www.insurancexdate.com/gl/53333',
  },
  {
    Code: 53374,
    Description: 'Food Products Mfg.--Dry',
    URL: 'https://www.insurancexdate.com/gl/53374',
  },
  {
    Code: 53375,
    Description: 'Food Products Mfg.--Frozen',
    URL: 'https://www.insurancexdate.com/gl/53375',
  },
  {
    Code: 53376,
    Description: 'Food Products Mfg.--Not Dry--In Glass Containers',
    URL: 'https://www.insurancexdate.com/gl/53376',
  },
  {
    Code: 53377,
    Description: 'Food Products Mfg.--Not Dry--In Other Than Glass Containers',
    URL: 'https://www.insurancexdate.com/gl/53377',
  },
  {
    Code: 53403,
    Description: 'Forging Work',
    URL: 'https://www.insurancexdate.com/gl/53403',
  },
  {
    Code: 53425,
    Description: 'Foundries',
    URL: 'https://www.insurancexdate.com/gl/53425',
  },
  {
    Code: 53565,
    Description: 'Fruit or Vegetable Juice Mfg.--No Bottling of Carbonated Beverages',
    URL: 'https://www.insurancexdate.com/gl/53565',
  },
  {
    Code: 53631,
    Description: 'Fur Garment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/53631',
  },
  {
    Code: 53632,
    Description: 'Fur or Pelt Processing',
    URL: 'https://www.insurancexdate.com/gl/53632',
  },
  {
    Code: 53731,
    Description: 'Furniture Mfg. or Assembling--Infants',
    URL: 'https://www.insurancexdate.com/gl/53731',
  },
  {
    Code: 53732,
    Description: 'Furniture Mfg. or Assembling--Other Than Wood',
    URL: 'https://www.insurancexdate.com/gl/53732',
  },
  {
    Code: 53733,
    Description: 'Furniture Mfg. or Assembling--Wood',
    URL: 'https://www.insurancexdate.com/gl/53733',
  },
  {
    Code: 53734,
    Description: 'Furniture or Woodwork Stripping, Refinishing or Repairing--Shop Only',
    URL: 'https://www.insurancexdate.com/gl/53734',
  },
  {
    Code: 53803,
    Description: 'Galvanizing or Tinning',
    URL: 'https://www.insurancexdate.com/gl/53803',
  },
  {
    Code: 53901,
    Description: 'Gas Mfg.--Toxic and Either Flammable, Explosive or Reactive',
    URL: 'https://www.insurancexdate.com/gl/53901',
  },
  {
    Code: 53902,
    Description: 'Gas Mfg.--Inert',
    URL: 'https://www.insurancexdate.com/gl/53902',
  },
  {
    Code: 53903,
    Description: 'Gas Mfg.--Other',
    URL: 'https://www.insurancexdate.com/gl/53903',
  },
  {
    Code: 53904,
    Description: 'Gas Mfg.--Primarily Flammable, Explosive or Reactive',
    URL: 'https://www.insurancexdate.com/gl/53904',
  },
  {
    Code: 53905,
    Description: 'Gas Mfg.--Primarily Toxic or Presenting a Health Hazard',
    URL: 'https://www.insurancexdate.com/gl/53905',
  },
  {
    Code: 53907,
    Description: 'Gasoline Distributors',
    URL: 'https://www.insurancexdate.com/gl/53907',
  },
  {
    Code: 54012,
    Description: 'Gemstone Cutting or Polishing',
    URL: 'https://www.insurancexdate.com/gl/54012',
  },
  {
    Code: 54077,
    Description: 'Glass or Glassware Mfg.',
    URL: 'https://www.insurancexdate.com/gl/54077',
  },
  {
    Code: 54444,
    Description: 'Manufacturers',
    URL: 'https://www.insurancexdate.com/gl/54444',
  },
  {
    Code: 55010,
    Description: 'Heating Equipment Mfg.--Coal or Wood',
    URL: 'https://www.insurancexdate.com/gl/55010',
  },
  {
    Code: 55011,
    Description: 'Heating Equipment Mfg.--Electric',
    URL: 'https://www.insurancexdate.com/gl/55011',
  },
  {
    Code: 55012,
    Description: 'Heating Equipment Mfg.--Fuel Oil or Kerosene',
    URL: 'https://www.insurancexdate.com/gl/55012',
  },
  {
    Code: 55013,
    Description: 'Heating Equipment Mfg.--Gas or Liquefied Petroleum Gas',
    URL: 'https://www.insurancexdate.com/gl/55013',
  },
  {
    Code: 55214,
    Description: 'Hone, Oilstone or Whetstone Mfg.',
    URL: 'https://www.insurancexdate.com/gl/55214',
  },
  {
    Code: 55371,
    Description: 'Honey Extracting',
    URL: 'https://www.insurancexdate.com/gl/55371',
  },
  {
    Code: 55410,
    Description: 'Importers',
    URL: 'https://www.insurancexdate.com/gl/55410',
  },
  {
    Code: 55426,
    Description: 'Ink Mfg.',
    URL: 'https://www.insurancexdate.com/gl/55426',
  },
  {
    Code: 55597,
    Description: 'Inner Tubes Mfg.',
    URL: 'https://www.insurancexdate.com/gl/55597',
  },
  {
    Code: 55647,
    Description: 'Instrument Mfg.--Analytical, Calibrating, Measuring, Testing or Recording',
    URL: 'https://www.insurancexdate.com/gl/55647',
  },
  {
    Code: 55648,
    Description: 'Instrument Mfg.--Control',
    URL: 'https://www.insurancexdate.com/gl/55648',
  },
  {
    Code: 55649,
    Description: 'Instrument Mfg.',
    URL: 'https://www.insurancexdate.com/gl/55649',
  },
  {
    Code: 55715,
    Description: 'Insulating Material Mfg.--Mineral',
    URL: 'https://www.insurancexdate.com/gl/55715',
  },
  {
    Code: 55716,
    Description: 'Insulating Material Mfg.--Organic',
    URL: 'https://www.insurancexdate.com/gl/55716',
  },
  {
    Code: 55717,
    Description: 'Insulating Material Mfg.--Plastic--for Application in a Solid State',
    URL: 'https://www.insurancexdate.com/gl/55717',
  },
  {
    Code: 55718,
    Description: 'Insulating Material Mfg.--Plastic',
    URL: 'https://www.insurancexdate.com/gl/55718',
  },
  {
    Code: 55802,
    Description: 'Jewelry Mfg.',
    URL: 'https://www.insurancexdate.com/gl/55802',
  },
  {
    Code: 55918,
    Description: 'Ladder Mfg.--Other Than Wood',
    URL: 'https://www.insurancexdate.com/gl/55918',
  },
  {
    Code: 55919,
    Description: 'Ladder Mfg.--Wood',
    URL: 'https://www.insurancexdate.com/gl/55919',
  },
  {
    Code: 56040,
    Description: 'Lamp Shade Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56040',
  },
  {
    Code: 56041,
    Description: 'Lamps or Lanterns Mfg.--Electric',
    URL: 'https://www.insurancexdate.com/gl/56041',
  },
  {
    Code: 56042,
    Description: 'Lamps or Lanterns Mfg.--Other Than Electric',
    URL: 'https://www.insurancexdate.com/gl/56042',
  },
  {
    Code: 56170,
    Description: 'Lead Mfg.--Red or White',
    URL: 'https://www.insurancexdate.com/gl/56170',
  },
  {
    Code: 56171,
    Description: 'Lead Works--Sheet, Pipe or Shot',
    URL: 'https://www.insurancexdate.com/gl/56171',
  },
  {
    Code: 56202,
    Description: 'Leather Goods Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56202',
  },
  {
    Code: 56390,
    Description: 'Light Bulb or Tubes Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56390',
  },
  {
    Code: 56391,
    Description: 'Lighting Fixtures Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56391',
  },
  {
    Code: 56427,
    Description: 'Lime Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56427',
  },
  {
    Code: 56488,
    Description: 'Liquor Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56488',
  },
  {
    Code: 56567,
    Description: 'Lubricants Mfg.--Grease',
    URL: 'https://www.insurancexdate.com/gl/56567',
  },
  {
    Code: 56650,
    Description: 'Machinery or Machinery Parts Mfg.--Construction, Mining or Materials Handling Type',
    URL: 'https://www.insurancexdate.com/gl/56650',
  },
  {
    Code: 56651,
    Description: 'Machinery or Machinery Parts Mfg.--Farm Type',
    URL: 'https://www.insurancexdate.com/gl/56651',
  },
  {
    Code: 56652,
    Description: 'Machinery or Machinery Parts Mfg.--Industrial Type',
    URL: 'https://www.insurancexdate.com/gl/56652',
  },
  {
    Code: 56653,
    Description: 'Machinery or Machinery Parts Mfg.--Metalworking',
    URL: 'https://www.insurancexdate.com/gl/56653',
  },
  {
    Code: 56654,
    Description: 'Machinery or Machinery Parts Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56654',
  },
  {
    Code: 56690,
    Description: 'Match Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56690',
  },
  {
    Code: 56699,
    Description: 'Mattress or Box Spring Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56699',
  },
  {
    Code: 56758,
    Description: 'Meat, Fish, Poultry or Seafood--Curing',
    URL: 'https://www.insurancexdate.com/gl/56758',
  },
  {
    Code: 56759,
    Description: 'Meat, Fish, Poultry or Seafood Processing--In Airtight Containers',
    URL: 'https://www.insurancexdate.com/gl/56759',
  },
  {
    Code: 56760,
    Description: 'Meat, Fish, Poultry or Seafood Processing--Not in Airtight Containers',
    URL: 'https://www.insurancexdate.com/gl/56760',
  },
  {
    Code: 56805,
    Description: 'Medical, Dental, Hospital or Surgical Equipment or Supplies Mfg.--Expendable',
    URL: 'https://www.insurancexdate.com/gl/56805',
  },
  {
    Code: 56806,
    Description: 'Medical, Dental, Hospital or Surgical Equipment or Supplies Mfg.--Nonexpendable',
    URL: 'https://www.insurancexdate.com/gl/56806',
  },
  {
    Code: 56807,
    Description: 'Medical, Dental, Hospital or Surgical Instruments Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56807',
  },
  {
    Code: 56808,
    Description: 'Medical, Dental or Surgical Diagnostic or Treatment Machines or Devices Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56808',
  },
  {
    Code: 56900,
    Description: 'Metals--Extraction or Refining',
    URL: 'https://www.insurancexdate.com/gl/56900',
  },
  {
    Code: 56910,
    Description: 'Metal Foil Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56910',
  },
  {
    Code: 56911,
    Description: 'Metal Goods Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56911',
  },
  {
    Code: 56912,
    Description: 'Metal Goods Mfg.--Stamping--Not Signs',
    URL: 'https://www.insurancexdate.com/gl/56912',
  },
  {
    Code: 56913,
    Description: 'Metal Heat Processing',
    URL: 'https://www.insurancexdate.com/gl/56913',
  },
  {
    Code: 56915,
    Description: 'Metal Works--Shop--Structural--Load Bearing',
    URL: 'https://www.insurancexdate.com/gl/56915',
  },
  {
    Code: 56916,
    Description: 'Metal Works--Shop--Structural--Not Load Bearing',
    URL: 'https://www.insurancexdate.com/gl/56916',
  },
  {
    Code: 56917,
    Description: 'Metals--Extraction or Refining--Chemical Processes',
    URL: 'https://www.insurancexdate.com/gl/56917',
  },
  {
    Code: 56918,
    Description: 'Metals--Extraction or Refining--Electrometallurgical Processes',
    URL: 'https://www.insurancexdate.com/gl/56918',
  },
  {
    Code: 56919,
    Description: 'Metals--Extraction or Refining of Ferrous Metals--Blast Furnace or Other Pyrometallurgical Processes',
    URL: 'https://www.insurancexdate.com/gl/56919',
  },
  {
    Code: 56920,
    Description:
      'Metals--Extraction or Refining of Nonferrous Metals--Blast Furnace or Other Pyrometallurgical Processes',
    URL: 'https://www.insurancexdate.com/gl/56920',
  },
  {
    Code: 56980,
    Description: 'Mica Goods Mfg.',
    URL: 'https://www.insurancexdate.com/gl/56980',
  },
  {
    Code: 57001,
    Description: 'Milk Depots or Dealers',
    URL: 'https://www.insurancexdate.com/gl/57001',
  },
  {
    Code: 57002,
    Description: 'Milk Processing',
    URL: 'https://www.insurancexdate.com/gl/57002',
  },
  {
    Code: 57090,
    Description: 'Mobile Home Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57090',
  },
  {
    Code: 57146,
    Description: 'Modular Units Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57146',
  },
  {
    Code: 57202,
    Description: 'Motorcycle, Moped or Motor Scooter Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57202',
  },
  {
    Code: 57257,
    Description: 'Musical Instrument Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57257',
  },
  {
    Code: 57401,
    Description: 'Nails or Spikes Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57401',
  },
  {
    Code: 57403,
    Description: 'Needles, Pins or Tacks Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57403',
  },
  {
    Code: 57410,
    Description: 'Net Mfg.--Other Than Safety Nets',
    URL: 'https://www.insurancexdate.com/gl/57410',
  },
  {
    Code: 57411,
    Description: 'Net Mfg.--Safety Nets',
    URL: 'https://www.insurancexdate.com/gl/57411',
  },
  {
    Code: 57572,
    Description: 'Office Machines Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57572',
  },
  {
    Code: 57600,
    Description: 'Optical Goods Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57600',
  },
  {
    Code: 57611,
    Description: 'Ore Milling or Processing',
    URL: 'https://www.insurancexdate.com/gl/57611',
  },
  {
    Code: 57625,
    Description: 'Orthopedic, Ambulation or Prosthetic Devices Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57625',
  },
  {
    Code: 57651,
    Description: 'Packing Houses',
    URL: 'https://www.insurancexdate.com/gl/57651',
  },
  {
    Code: 57690,
    Description: 'Paint, Varnish, Shellac or Lacquer Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57690',
  },
  {
    Code: 57716,
    Description: 'Paper Coating or Finishing',
    URL: 'https://www.insurancexdate.com/gl/57716',
  },
  {
    Code: 57725,
    Description: 'Paper Goods Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57725',
  },
  {
    Code: 57726,
    Description: 'Paper Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57726',
  },
  {
    Code: 57798,
    Description: 'Parachute Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57798',
  },
  {
    Code: 57800,
    Description: 'Media Mfg.--Blank',
    URL: 'https://www.insurancexdate.com/gl/57800',
  },
  {
    Code: 57808,
    Description: 'Pattern Mfg.--Metal',
    URL: 'https://www.insurancexdate.com/gl/57808',
  },
  {
    Code: 57809,
    Description: 'Pattern Mfg.--Other',
    URL: 'https://www.insurancexdate.com/gl/57809',
  },
  {
    Code: 57810,
    Description: 'Pattern Mfg.--Paper',
    URL: 'https://www.insurancexdate.com/gl/57810',
  },
  {
    Code: 57871,
    Description: 'Pencil, Pen, Crayon or Chalk Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57871',
  },
  {
    Code: 57913,
    Description: 'Pet Food Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57913',
  },
  {
    Code: 57997,
    Description: 'Photo Finishing Laboratories',
    URL: 'https://www.insurancexdate.com/gl/57997',
  },
  {
    Code: 57998,
    Description: 'Photographic Equipment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57998',
  },
  {
    Code: 57999,
    Description: 'Photographic Supplies Mfg.',
    URL: 'https://www.insurancexdate.com/gl/57999',
  },
  {
    Code: 58009,
    Description: 'Pipes or Tubes Mfg.--Metal',
    URL: 'https://www.insurancexdate.com/gl/58009',
  },
  {
    Code: 58010,
    Description: 'Pipes or Tubes Mfg.--Plastic',
    URL: 'https://www.insurancexdate.com/gl/58010',
  },
  {
    Code: 58020,
    Description: 'Pipes Mfg.--Tobacco',
    URL: 'https://www.insurancexdate.com/gl/58020',
  },
  {
    Code: 58056,
    Description: 'Plastic Mfg.--Raw Material',
    URL: 'https://www.insurancexdate.com/gl/58056',
  },
  {
    Code: 58057,
    Description: 'Plastic or Rubber Goods Mfg.--Household',
    URL: 'https://www.insurancexdate.com/gl/58057',
  },
  {
    Code: 58058,
    Description: 'Plastic or Rubber Goods Mfg.--Other Than Household',
    URL: 'https://www.insurancexdate.com/gl/58058',
  },
  {
    Code: 58095,
    Description: 'Plumbing Fixtures Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58095',
  },
  {
    Code: 58096,
    Description: 'Plumbing Supplies Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58096',
  },
  {
    Code: 58301,
    Description: 'Plywood, Veneer or Veneer Products Mfg.--Other',
    URL: 'https://www.insurancexdate.com/gl/58301',
  },
  {
    Code: 58302,
    Description: 'Plywood, Veneer or Veneer Products Mfg.--without Log Processing',
    URL: 'https://www.insurancexdate.com/gl/58302',
  },
  {
    Code: 58397,
    Description: 'Prefabricated Building Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58397',
  },
  {
    Code: 58408,
    Description: 'Printing--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/58408',
  },
  {
    Code: 58409,
    Description: 'Printing--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/58409',
  },
  {
    Code: 58456,
    Description: 'Publishers--Books or Magazines--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/58456',
  },
  {
    Code: 58457,
    Description: 'Publishers--Books or Magazines--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/58457',
  },
  {
    Code: 58458,
    Description: 'Publishers--Newspapers--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/58458',
  },
  {
    Code: 58459,
    Description: 'Publishers--Newspapers--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/58459',
  },
  {
    Code: 58503,
    Description: 'Pulp Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58503',
  },
  {
    Code: 58532,
    Description: 'Pumps or Compressors Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58532',
  },
  {
    Code: 58559,
    Description: 'Railroad Engine Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58559',
  },
  {
    Code: 58560,
    Description: 'Railroad or Other Public Conveyance Cars Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58560',
  },
  {
    Code: 58561,
    Description: 'Railroad or Other Public Conveyance Cars Parts Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58561',
  },
  {
    Code: 58575,
    Description: 'Razor or Razor Blades Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58575',
  },
  {
    Code: 58627,
    Description: 'Media Mfg.--Pre-Recorded',
    URL: 'https://www.insurancexdate.com/gl/58627',
  },
  {
    Code: 58663,
    Description: 'Refrigeration Equipment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58663',
  },
  {
    Code: 58682,
    Description: 'Rendering Works',
    URL: 'https://www.insurancexdate.com/gl/58682',
  },
  {
    Code: 58713,
    Description: 'Rolling Mills--Cold or Hot Process',
    URL: 'https://www.insurancexdate.com/gl/58713',
  },
  {
    Code: 58737,
    Description: 'Rope Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58737',
  },
  {
    Code: 58756,
    Description: 'Rubber Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58756',
  },
  {
    Code: 58757,
    Description: 'Rubber Reclaiming',
    URL: 'https://www.insurancexdate.com/gl/58757',
  },
  {
    Code: 58759,
    Description: 'Rubber Stamp Mfg. or Assembling',
    URL: 'https://www.insurancexdate.com/gl/58759',
  },
  {
    Code: 58802,
    Description: 'Saddles, Harnesses or Horses Furnishings Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58802',
  },
  {
    Code: 58813,
    Description: 'Safes or Safe Vaults Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58813',
  },
  {
    Code: 58822,
    Description: 'Sail Making',
    URL: 'https://www.insurancexdate.com/gl/58822',
  },
  {
    Code: 58837,
    Description: 'Salt, Borax, Potash or Phosphate--Producing or Refining',
    URL: 'https://www.insurancexdate.com/gl/58837',
  },
  {
    Code: 58840,
    Description: 'Salt Mfg.',
    URL: 'https://www.insurancexdate.com/gl/58840',
  },
  {
    Code: 58873,
    Description: 'Saw Mills or Planing Mills',
    URL: 'https://www.insurancexdate.com/gl/58873',
  },
  {
    Code: 58903,
    Description: 'Sewing Machines Mfg.--Commercial',
    URL: 'https://www.insurancexdate.com/gl/58903',
  },
  {
    Code: 58904,
    Description: 'Sewing Machines Mfg.--Household',
    URL: 'https://www.insurancexdate.com/gl/58904',
  },
  {
    Code: 58922,
    Description: 'Sheet Metal Work--Shop Only',
    URL: 'https://www.insurancexdate.com/gl/58922',
  },
  {
    Code: 59005,
    Description: 'Shoe, Boot or Slipper Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59005',
  },
  {
    Code: 59057,
    Description: 'Sign Mfg.--Electrical',
    URL: 'https://www.insurancexdate.com/gl/59057',
  },
  {
    Code: 59058,
    Description: 'Sign Mfg.--Other Than Electrical',
    URL: 'https://www.insurancexdate.com/gl/59058',
  },
  {
    Code: 59188,
    Description: 'Slate Milling',
    URL: 'https://www.insurancexdate.com/gl/59188',
  },
  {
    Code: 59189,
    Description: 'Slate Splitting or Slate Roofing Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59189',
  },
  {
    Code: 59223,
    Description: 'Soap Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59223',
  },
  {
    Code: 59257,
    Description: 'Sponge Processing',
    URL: 'https://www.insurancexdate.com/gl/59257',
  },
  {
    Code: 59306,
    Description: 'Sporting Goods or Athletic Equipment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59306',
  },
  {
    Code: 59378,
    Description: 'Steel Wool or Wire Wool Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59378',
  },
  {
    Code: 59481,
    Description: 'Stone Crushing',
    URL: 'https://www.insurancexdate.com/gl/59481',
  },
  {
    Code: 59482,
    Description: 'Stone Cutting or Polishing',
    URL: 'https://www.insurancexdate.com/gl/59482',
  },
  {
    Code: 59537,
    Description: 'Sugar Refining',
    URL: 'https://www.insurancexdate.com/gl/59537',
  },
  {
    Code: 59601,
    Description: 'Swimming Pools or Accessories Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59601',
  },
  {
    Code: 59647,
    Description: 'Syrups or Molasses--Refining, Blending or Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59647',
  },
  {
    Code: 59660,
    Description: 'Tank Building or Mfg.--Metal--Not Pressurized',
    URL: 'https://www.insurancexdate.com/gl/59660',
  },
  {
    Code: 59661,
    Description: 'Tank Building or Mfg.--Metal--Pressurized',
    URL: 'https://www.insurancexdate.com/gl/59661',
  },
  {
    Code: 59693,
    Description: 'Tanning--Animal Hides',
    URL: 'https://www.insurancexdate.com/gl/59693',
  },
  {
    Code: 59695,
    Description: 'Telecommunication Equipment Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59695',
  },
  {
    Code: 59701,
    Description: 'Television Picture Tube Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59701',
  },
  {
    Code: 59713,
    Description: 'Tent or Canopy Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59713',
  },
  {
    Code: 59722,
    Description: 'Textile Bleaching, Dyeing, Mercerizing, Printing, Finishing or Silk Screening--New Goods',
    URL: 'https://www.insurancexdate.com/gl/59722',
  },
  {
    Code: 59723,
    Description: 'Textile Coating or Impregnating',
    URL: 'https://www.insurancexdate.com/gl/59723',
  },
  {
    Code: 59724,
    Description: 'Textile Mfg.--Impregnated or Coated',
    URL: 'https://www.insurancexdate.com/gl/59724',
  },
  {
    Code: 59725,
    Description: 'Textile Products Mfg.--Fabricated',
    URL: 'https://www.insurancexdate.com/gl/59725',
  },
  {
    Code: 59726,
    Description: 'Textile Spinning, Weaving or Knitting Mills',
    URL: 'https://www.insurancexdate.com/gl/59726',
  },
  {
    Code: 59738,
    Description: 'Tie, Post or Pole Yard',
    URL: 'https://www.insurancexdate.com/gl/59738',
  },
  {
    Code: 59750,
    Description: 'Tire Mfg.--Auto, Bus or Truck',
    URL: 'https://www.insurancexdate.com/gl/59750',
  },
  {
    Code: 59751,
    Description: 'Tire Mfg.--Not Auto, Bus or Truck',
    URL: 'https://www.insurancexdate.com/gl/59751',
  },
  {
    Code: 59773,
    Description: 'Tobacco Products Mfg.--Cigars or Cigarettes',
    URL: 'https://www.insurancexdate.com/gl/59773',
  },
  {
    Code: 59774,
    Description: 'Tobacco Products Mfg.--Other',
    URL: 'https://www.insurancexdate.com/gl/59774',
  },
  {
    Code: 59775,
    Description: 'Tobacco Products Mfg.--Plug or Snuff',
    URL: 'https://www.insurancexdate.com/gl/59775',
  },
  {
    Code: 59781,
    Description: 'Tool Mfg.--Accessories',
    URL: 'https://www.insurancexdate.com/gl/59781',
  },
  {
    Code: 59782,
    Description: 'Tool Mfg.--Hand Type--Not Powered',
    URL: 'https://www.insurancexdate.com/gl/59782',
  },
  {
    Code: 59783,
    Description: 'Tool Mfg.--Hand Type--Powered',
    URL: 'https://www.insurancexdate.com/gl/59783',
  },
  {
    Code: 59784,
    Description: 'Tool Mfg.--Power Equipment--Household Type--Outdoor or Workshop',
    URL: 'https://www.insurancexdate.com/gl/59784',
  },
  {
    Code: 59790,
    Description: 'Toys or Games Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59790',
  },
  {
    Code: 59798,
    Description: 'Trailers Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59798',
  },
  {
    Code: 59806,
    Description: 'Truck Mfg. or Assembling',
    URL: 'https://www.insurancexdate.com/gl/59806',
  },
  {
    Code: 59867,
    Description: 'Turpentine or Resin Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59867',
  },
  {
    Code: 59886,
    Description: 'Twine or Cordage Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59886',
  },
  {
    Code: 59889,
    Description: 'Umbrella or Cane Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59889',
  },
  {
    Code: 59892,
    Description: 'Valves Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59892',
  },
  {
    Code: 59904,
    Description: 'Vegetable Oil Mfg.--By Solvent Extraction',
    URL: 'https://www.insurancexdate.com/gl/59904',
  },
  {
    Code: 59905,
    Description: 'Vegetable Oil Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59905',
  },
  {
    Code: 59914,
    Description: 'Metal Works--Shop--Decorative or Artistic',
    URL: 'https://www.insurancexdate.com/gl/59914',
  },
  {
    Code: 59915,
    Description: 'Vending Machines Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59915',
  },
  {
    Code: 59917,
    Description: 'Venetian Blinds Mfg. or Assembling',
    URL: 'https://www.insurancexdate.com/gl/59917',
  },
  {
    Code: 59923,
    Description: 'Watch or Watch Case Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59923',
  },
  {
    Code: 59925,
    Description: 'Water Bottling--In Siphons',
    URL: 'https://www.insurancexdate.com/gl/59925',
  },
  {
    Code: 59926,
    Description: 'Water Bottling--Spring or Well--Not Sparkling or Carbonated',
    URL: 'https://www.insurancexdate.com/gl/59926',
  },
  {
    Code: 59927,
    Description: 'Water Bottling--Spring or Well--Sparkling or Carbonated',
    URL: 'https://www.insurancexdate.com/gl/59927',
  },
  {
    Code: 59931,
    Description: 'Wax or Wax Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59931',
  },
  {
    Code: 59932,
    Description: 'Wax, Wax Products or Polish Mfg.--Floor',
    URL: 'https://www.insurancexdate.com/gl/59932',
  },
  {
    Code: 59941,
    Description: 'Wheel Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59941',
  },
  {
    Code: 59947,
    Description: 'Wicker, Rattan, Willow or Twisted Fiber Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59947',
  },
  {
    Code: 59955,
    Description: 'Wigs or Hair Pieces Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59955',
  },
  {
    Code: 59963,
    Description: 'Wine Mfg.--Sparkling',
    URL: 'https://www.insurancexdate.com/gl/59963',
  },
  {
    Code: 59964,
    Description: 'Wine Mfg.--Still',
    URL: 'https://www.insurancexdate.com/gl/59964',
  },
  {
    Code: 59970,
    Description: 'Wire Cloth Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59970',
  },
  {
    Code: 59973,
    Description: 'Wire Drawing',
    URL: 'https://www.insurancexdate.com/gl/59973',
  },
  {
    Code: 59975,
    Description: 'Wire Goods Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59975',
  },
  {
    Code: 59977,
    Description: 'Wire Rope or Cable Mfg.--Metal',
    URL: 'https://www.insurancexdate.com/gl/59977',
  },
  {
    Code: 59984,
    Description: 'Wood Preserving',
    URL: 'https://www.insurancexdate.com/gl/59984',
  },
  {
    Code: 59985,
    Description: 'Wood Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59985',
  },
  {
    Code: 59986,
    Description: 'Wood Turned Products Mfg.',
    URL: 'https://www.insurancexdate.com/gl/59986',
  },
  {
    Code: 59988,
    Description: 'Wool Combing, Scouring or Separating from Cotton',
    URL: 'https://www.insurancexdate.com/gl/59988',
  },
  {
    Code: 59989,
    Description: 'Wool Pulling',
    URL: 'https://www.insurancexdate.com/gl/59989',
  },
  {
    Code: 60010,
    Description: 'Apartment Buildings',
    URL: 'https://www.insurancexdate.com/gl/60010',
  },
  {
    Code: 60011,
    Description: 'Apartment Buildings--Garden',
    URL: 'https://www.insurancexdate.com/gl/60011',
  },
  {
    Code: 60012,
    Description: 'Apartment Buildings or Hotels Time-Sharing--Less Than 4 Stories',
    URL: 'https://www.insurancexdate.com/gl/60012',
  },
  {
    Code: 60013,
    Description: 'Apartment Buildings or Hotels Time-Sharing--4 Stories or More',
    URL: 'https://www.insurancexdate.com/gl/60013',
  },
  {
    Code: 60015,
    Description: 'Apartment Hotels--Less Than 4 Stories',
    URL: 'https://www.insurancexdate.com/gl/60015',
  },
  {
    Code: 60016,
    Description: 'Apartment Hotels--4 Stories or More',
    URL: 'https://www.insurancexdate.com/gl/60016',
  },
  {
    Code: 60035,
    Description: 'Automobile Renting or Leasing Companies',
    URL: 'https://www.insurancexdate.com/gl/60035',
  },
  {
    Code: 61000,
    Description: 'Boarding or Rooming Houses',
    URL: 'https://www.insurancexdate.com/gl/61000',
  },
  {
    Code: 61212,
    Description:
      "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/61212',
  },
  {
    Code: 61216,
    Description: "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/61216',
  },
  {
    Code: 61217,
    Description:
      "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Maintained by the Insured--Other Than Not-For-Profit",
    URL: 'https://www.insurancexdate.com/gl/61217',
  },
  {
    Code: 61218,
    Description:
      "Buildings or Premises--Bank or Office--Mercantile or Mfg. (Lessor's Risk Only)--Maintained by the Insured--Not-For-Profit Only",
    URL: 'https://www.insurancexdate.com/gl/61218',
  },
  {
    Code: 61223,
    Description: 'Buildings or Premises--Bank and Other Financial Institutions',
    URL: 'https://www.insurancexdate.com/gl/61223',
  },
  {
    Code: 61224,
    Description:
      'Buildings or Premises--Office--Premises Occupied by Employees of the Insured--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/61224',
  },
  {
    Code: 61225,
    Description: 'Buildings or Premises--Office--Premises Occupied by Employees of the Insured--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/61225',
  },
  {
    Code: 61226,
    Description: 'Buildings or Premises--Office--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/61226',
  },
  {
    Code: 61227,
    Description: 'Buildings or Premises--Office--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/61227',
  },
  {
    Code: 62000,
    Description: 'Condominiums--Commercial--Bank or Mercantile, Mfg. or Office (Association Risk Only)',
    URL: 'https://www.insurancexdate.com/gl/62000',
  },
  {
    Code: 62001,
    Description: 'Condominiums--Commercial Shopping Centers (Association Risk Only)',
    URL: 'https://www.insurancexdate.com/gl/62001',
  },
  {
    Code: 62002,
    Description: 'Condominiums--Commercial Warehouses--Mfg. or Private (Association Risk Only)',
    URL: 'https://www.insurancexdate.com/gl/62002',
  },
  {
    Code: 62003,
    Description: 'Condominiums--Residential--(Association Risk Only)',
    URL: 'https://www.insurancexdate.com/gl/62003',
  },
  {
    Code: 63010,
    Description: "Dwellings--One-Family (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/63010',
  },
  {
    Code: 63011,
    Description: "Dwellings--Two-Family (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/63011',
  },
  {
    Code: 63012,
    Description: "Dwellings--Three-Family (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/63012',
  },
  {
    Code: 63013,
    Description: "Dwellings--Four-Family (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/63013',
  },
  {
    Code: 63215,
    Description: 'Exhibition or Convention Buildings--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/63215',
  },
  {
    Code: 63216,
    Description: 'Exhibition or Convention Buildings--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/63216',
  },
  {
    Code: 63217,
    Description: 'Exhibitions--In Buildings--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/63217',
  },
  {
    Code: 63218,
    Description: 'Exhibitions--In Buildings--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/63218',
  },
  {
    Code: 63219,
    Description: 'Exhibitions--In Buildings--No Admission Charged--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/63219',
  },
  {
    Code: 63220,
    Description: 'Exhibitions--In Buildings--No Admission Charged--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/63220',
  },
  {
    Code: 64074,
    Description: "Hotels and Motels--(Lessor's Risk Only)--Less Than Four Stories",
    URL: 'https://www.insurancexdate.com/gl/64074',
  },
  {
    Code: 64075,
    Description: "Hotels and Motels--(Lessor's Risk Only)--Four Stories or More",
    URL: 'https://www.insurancexdate.com/gl/64075',
  },
  {
    Code: 64500,
    Description: 'Housing Projects--Federal, State, Local',
    URL: 'https://www.insurancexdate.com/gl/64500',
  },
  {
    Code: 65007,
    Description: 'Labor Union Offices',
    URL: 'https://www.insurancexdate.com/gl/65007',
  },
  {
    Code: 66122,
    Description: 'Lawyers Offices--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/66122',
  },
  {
    Code: 66123,
    Description: 'Lawyers Offices--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/66123',
  },
  {
    Code: 66309,
    Description: 'Libraries',
    URL: 'https://www.insurancexdate.com/gl/66309',
  },
  {
    Code: 66561,
    Description: 'Medical Offices',
    URL: 'https://www.insurancexdate.com/gl/66561',
  },
  {
    Code: 67017,
    Description: 'Shelters, Mission, Settlement or Halfway Houses--Not Church or Office Building',
    URL: 'https://www.insurancexdate.com/gl/67017',
  },
  {
    Code: 67508,
    Description: 'Schools--Colleges, Universities, Junior Colleges or College Preparatory Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/67508',
  },
  {
    Code: 67509,
    Description: 'Schools--Colleges, Universities, Junior Colleges or College Preparatory Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/67509',
  },
  {
    Code: 67510,
    Description: 'Schools--Dormitory Facilities--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/67510',
  },
  {
    Code: 67511,
    Description: 'Schools--Dormitory Facilities--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/67511',
  },
  {
    Code: 67512,
    Description: 'Schools--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/67512',
  },
  {
    Code: 67513,
    Description: 'Schools--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/67513',
  },
  {
    Code: 67634,
    Description:
      "Shopping Centers--Indoor Malls--Buildings or Premises Not Occupied by the Insured (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/67634',
  },
  {
    Code: 67635,
    Description: "Shopping Centers--Buildings or Premises Not Occupied by the Insured (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/67635',
  },
  {
    Code: 68001,
    Description: 'Taxicab Companies',
    URL: 'https://www.insurancexdate.com/gl/68001',
  },
  {
    Code: 68439,
    Description: 'Ticket Agencies',
    URL: 'https://www.insurancexdate.com/gl/68439',
  },
  {
    Code: 68500,
    Description: 'Townhouses or Similar Associations (Association Risk Only)',
    URL: 'https://www.insurancexdate.com/gl/68500',
  },
  {
    Code: 68604,
    Description: 'Vacant Buildings--Factories',
    URL: 'https://www.insurancexdate.com/gl/68604',
  },
  {
    Code: 68606,
    Description: 'Vacant Buildings--Not Factories--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/68606',
  },
  {
    Code: 68607,
    Description: 'Vacant Buildings--Not Factories--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/68607',
  },
  {
    Code: 68702,
    Description: "Warehouses--Occupied by Multiple Interests (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/68702',
  },
  {
    Code: 68703,
    Description: "Warehouses--Occupied by Single Interest (Lessor's Risk Only)",
    URL: 'https://www.insurancexdate.com/gl/68703',
  },
  {
    Code: 68706,
    Description: 'Warehouses--Private--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/68706',
  },
  {
    Code: 68707,
    Description: 'Warehouses--Private--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/68707',
  },
  {
    Code: 90089,
    Description: 'Advertising Sign Companies--Outdoor',
    URL: 'https://www.insurancexdate.com/gl/90089',
  },
  {
    Code: 91111,
    Description: 'Air Conditioning Systems or Equipment--Dealers or Distributors and Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/91111',
  },
  {
    Code: 91125,
    Description: 'Airport Runway or Warming Apron--Paving or Repaving, Surfacing, Resurfacing or Scraping',
    URL: 'https://www.insurancexdate.com/gl/91125',
  },
  {
    Code: 91127,
    Description: 'Alarms and Alarm Systems--Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/91127',
  },
  {
    Code: 91130,
    Description: 'Alarms--Security Systems--Monitoring',
    URL: 'https://www.insurancexdate.com/gl/91130',
  },
  {
    Code: 91135,
    Description: 'Analytical Chemists',
    URL: 'https://www.insurancexdate.com/gl/91135',
  },
  {
    Code: 91150,
    Description: 'Appliances and Accessories--Installation, Servicing or Repair--Commercial',
    URL: 'https://www.insurancexdate.com/gl/91150',
  },
  {
    Code: 91155,
    Description: 'Appliances and Accessories--Installation, Servicing or Repair--Household',
    URL: 'https://www.insurancexdate.com/gl/91155',
  },
  {
    Code: 91160,
    Description: 'Armored Car Service Companies',
    URL: 'https://www.insurancexdate.com/gl/91160',
  },
  {
    Code: 91175,
    Description: "Auctioneers--Livestock--Sales Conducted Away from the Insured's Premises",
    URL: 'https://www.insurancexdate.com/gl/91175',
  },
  {
    Code: 91177,
    Description: "Auctioneers--Sales Conducted Away from the Insured's Premises",
    URL: 'https://www.insurancexdate.com/gl/91177',
  },
  {
    Code: 91179,
    Description: 'Auctions--on Premises Owned or Rented by the Insured',
    URL: 'https://www.insurancexdate.com/gl/91179',
  },
  {
    Code: 91190,
    Description: 'Automobile Dismantling',
    URL: 'https://www.insurancexdate.com/gl/91190',
  },
  {
    Code: 91200,
    Description: 'Blacksmithing',
    URL: 'https://www.insurancexdate.com/gl/91200',
  },
  {
    Code: 91210,
    Description: 'Blasting Operations',
    URL: 'https://www.insurancexdate.com/gl/91210',
  },
  {
    Code: 91235,
    Description: 'Boat Repair and Servicing',
    URL: 'https://www.insurancexdate.com/gl/91235',
  },
  {
    Code: 91250,
    Description: 'Boiler Inspection, Installation, Cleaning or Repair',
    URL: 'https://www.insurancexdate.com/gl/91250',
  },
  {
    Code: 91265,
    Description: 'Bridge or Elevated Highway Construction--Iron or Steel',
    URL: 'https://www.insurancexdate.com/gl/91265',
  },
  {
    Code: 91266,
    Description: 'Bridge or Elevated Highway Construction--Concrete',
    URL: 'https://www.insurancexdate.com/gl/91266',
  },
  {
    Code: 91280,
    Description: 'Building Structure--Raising or Moving',
    URL: 'https://www.insurancexdate.com/gl/91280',
  },
  {
    Code: 91302,
    Description: 'Cable Installation in Conduits or Subways',
    URL: 'https://www.insurancexdate.com/gl/91302',
  },
  {
    Code: 91315,
    Description: 'Cable or Subscription Television Companies',
    URL: 'https://www.insurancexdate.com/gl/91315',
  },
  {
    Code: 91324,
    Description: 'Caisson or Cofferdam Work--Foundations for Buildings',
    URL: 'https://www.insurancexdate.com/gl/91324',
  },
  {
    Code: 91325,
    Description: 'Caisson or Cofferdam Work--Not Foundations for Buildings',
    URL: 'https://www.insurancexdate.com/gl/91325',
  },
  {
    Code: 91340,
    Description: 'Carpentry--Construction of Residential Property Not Exceeding Three Stories in Height',
    URL: 'https://www.insurancexdate.com/gl/91340',
  },
  {
    Code: 91341,
    Description: 'Carpentry--Interior',
    URL: 'https://www.insurancexdate.com/gl/91341',
  },
  {
    Code: 91342,
    Description: 'Carpentry',
    URL: 'https://www.insurancexdate.com/gl/91342',
  },
  {
    Code: 91343,
    Description: 'Carpentry--Shop Only',
    URL: 'https://www.insurancexdate.com/gl/91343',
  },
  {
    Code: 91405,
    Description: "Carpet, Rug, Furniture or Upholstery Cleaning--on Customers' Premises",
    URL: 'https://www.insurancexdate.com/gl/91405',
  },
  {
    Code: 91436,
    Description: 'Ceiling or Wall Installation--Metal',
    URL: 'https://www.insurancexdate.com/gl/91436',
  },
  {
    Code: 91481,
    Description: 'Chimney Cleaning',
    URL: 'https://www.insurancexdate.com/gl/91481',
  },
  {
    Code: 91507,
    Description: 'Clay or Shale Digging',
    URL: 'https://www.insurancexdate.com/gl/91507',
  },
  {
    Code: 91523,
    Description: 'Cleaning--Outside Surfaces of Buildings & Other Exterior Surfaces',
    URL: 'https://www.insurancexdate.com/gl/91523',
  },
  {
    Code: 91547,
    Description: 'Commissary Work',
    URL: 'https://www.insurancexdate.com/gl/91547',
  },
  {
    Code: 91551,
    Description: 'Communication Equipment Installation--Industrial or Commercial',
    URL: 'https://www.insurancexdate.com/gl/91551',
  },
  {
    Code: 91555,
    Description: 'Computer Service or Repair',
    URL: 'https://www.insurancexdate.com/gl/91555',
  },
  {
    Code: 91560,
    Description: 'Concrete Construction',
    URL: 'https://www.insurancexdate.com/gl/91560',
  },
  {
    Code: 91562,
    Description:
      'Concrete or Cement Distributing Towers--Rented to Others--Installation, Repair or Removal Operations Only',
    URL: 'https://www.insurancexdate.com/gl/91562',
  },
  {
    Code: 91577,
    Description: 'Conduit Construction for Cables or Wires',
    URL: 'https://www.insurancexdate.com/gl/91577',
  },
  {
    Code: 91580,
    Description: 'Contractors--Executive Supervisors or Executive Superintendents',
    URL: 'https://www.insurancexdate.com/gl/91580',
  },
  {
    Code: 91581,
    Description:
      'Contractors--Subcontracted Work--In Connection with Construction, Reconstruction, Erection or Repair--Not Buildings',
    URL: 'https://www.insurancexdate.com/gl/91581',
  },
  {
    Code: 91582,
    Description:
      'Contractors--Subcontracted Work--In Connection with Building Construction, Reconstruction, Repair or Erection--Apartment or Office Buildings over Four Stories',
    URL: 'https://www.insurancexdate.com/gl/91582',
  },
  {
    Code: 91583,
    Description:
      'Contractors--Subcontracted Work--In Connection with Building Construction, Reconstruction, Repair or Erection--One- or Two-Family Dwellings',
    URL: 'https://www.insurancexdate.com/gl/91583',
  },
  {
    Code: 91584,
    Description:
      'Contractors--Subcontracted Work--In Connection with Construction, Reconstruction, Repair or Erection of Buildings--for Industrial Use',
    URL: 'https://www.insurancexdate.com/gl/91584',
  },
  {
    Code: 91585,
    Description:
      'Contractors--Subcontracted Work--In Connection with Construction, Reconstruction, Repair or Erection of Buildings',
    URL: 'https://www.insurancexdate.com/gl/91585',
  },
  {
    Code: 91586,
    Description:
      'Contractors--Subcontracted Work--In Connection with Oil and Gas Field Construction, Reconstruction or Repair',
    URL: 'https://www.insurancexdate.com/gl/91586',
  },
  {
    Code: 91587,
    Description:
      'Contractors--Subcontracted Work--In Connection with Pipeline (Other Than Oil or Gas) or Communication or Power Line Construction, Reconstruction or Repair',
    URL: 'https://www.insurancexdate.com/gl/91587',
  },
  {
    Code: 91588,
    Description:
      'Contractors--Subcontracted Work--In Connection with Bridge, Tunnel, Elevated Street or Highway Construction, Reconstruction or Repair',
    URL: 'https://www.insurancexdate.com/gl/91588',
  },
  {
    Code: 91589,
    Description:
      'Contractors--Subcontracted Work--In Connection with Street or Highway Construction or Repair, Not Elevated',
    URL: 'https://www.insurancexdate.com/gl/91589',
  },
  {
    Code: 91590,
    Description: 'Contractors Permanent Yards--Maintenance or Storage of Equipment or Material',
    URL: 'https://www.insurancexdate.com/gl/91590',
  },
  {
    Code: 91591,
    Description: 'Contractors--Subcontracted Work--Other Than Construction-Related Work',
    URL: 'https://www.insurancexdate.com/gl/91591',
  },
  {
    Code: 91600,
    Description: 'Construction or Project Manager',
    URL: 'https://www.insurancexdate.com/gl/91600',
  },
  {
    Code: 91606,
    Description: 'Crop Spraying--by Contractors',
    URL: 'https://www.insurancexdate.com/gl/91606',
  },
  {
    Code: 91618,
    Description: 'Dam or Reservoir Construction',
    URL: 'https://www.insurancexdate.com/gl/91618',
  },
  {
    Code: 91629,
    Description: 'Debris Removal--Construction Site',
    URL: 'https://www.insurancexdate.com/gl/91629',
  },
  {
    Code: 91636,
    Description: 'Detective or Investigative Agencies--Private',
    URL: 'https://www.insurancexdate.com/gl/91636',
  },
  {
    Code: 91641,
    Description: 'Dike, Levee or Revetment Construction',
    URL: 'https://www.insurancexdate.com/gl/91641',
  },
  {
    Code: 91666,
    Description: 'Diving--Marine',
    URL: 'https://www.insurancexdate.com/gl/91666',
  },
  {
    Code: 91722,
    Description: 'Dock Operations--Coal, Grain or Ore',
    URL: 'https://www.insurancexdate.com/gl/91722',
  },
  {
    Code: 91746,
    Description: 'Door, Window or Assembled Millwork--Installation--Metal',
    URL: 'https://www.insurancexdate.com/gl/91746',
  },
  {
    Code: 91805,
    Description: 'Draftsmen',
    URL: 'https://www.insurancexdate.com/gl/91805',
  },
  {
    Code: 92053,
    Description: 'Dredging--Gold--Endless Bucket or Ladder Type',
    URL: 'https://www.insurancexdate.com/gl/92053',
  },
  {
    Code: 92054,
    Description: 'Dredging--Gold--Floating Dragline Type',
    URL: 'https://www.insurancexdate.com/gl/92054',
  },
  {
    Code: 92055,
    Description: 'Dredging',
    URL: 'https://www.insurancexdate.com/gl/92055',
  },
  {
    Code: 92101,
    Description: 'Drilling--Other Than Water',
    URL: 'https://www.insurancexdate.com/gl/92101',
  },
  {
    Code: 92102,
    Description: 'Drilling--Water',
    URL: 'https://www.insurancexdate.com/gl/92102',
  },
  {
    Code: 92215,
    Description: 'Driveway, Parking Area or Sidewalk--Paving or Repaving',
    URL: 'https://www.insurancexdate.com/gl/92215',
  },
  {
    Code: 92338,
    Description: 'Dry Wall or Wallboard Installation',
    URL: 'https://www.insurancexdate.com/gl/92338',
  },
  {
    Code: 92445,
    Description: 'Electric Light or Power Companies',
    URL: 'https://www.insurancexdate.com/gl/92445',
  },
  {
    Code: 92446,
    Description: 'Electric Light or Power Line Construction',
    URL: 'https://www.insurancexdate.com/gl/92446',
  },
  {
    Code: 92447,
    Description: 'Electric Light or Power Line Construction--Rural Utilities Service Projects Only',
    URL: 'https://www.insurancexdate.com/gl/92447',
  },
  {
    Code: 92451,
    Description: 'Electrical Apparatus--Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/92451',
  },
  {
    Code: 92478,
    Description: 'Electrical Work--within Buildings',
    URL: 'https://www.insurancexdate.com/gl/92478',
  },
  {
    Code: 92593,
    Description: 'Elevator or Escalator Inspecting, Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/92593',
  },
  {
    Code: 92663,
    Description: 'Engineers or Architects--Consulting--Not Engaged in Actual Construction',
    URL: 'https://www.insurancexdate.com/gl/92663',
  },
  {
    Code: 94007,
    Description: 'Excavation',
    URL: 'https://www.insurancexdate.com/gl/94007',
  },
  {
    Code: 94099,
    Description: 'Express Companies',
    URL: 'https://www.insurancexdate.com/gl/94099',
  },
  {
    Code: 94225,
    Description: 'Farm Machinery Operations--by Contractors',
    URL: 'https://www.insurancexdate.com/gl/94225',
  },
  {
    Code: 94276,
    Description: 'Fence Erection Contractors',
    URL: 'https://www.insurancexdate.com/gl/94276',
  },
  {
    Code: 94304,
    Description: 'Fire Extinguishers--Servicing, Refilling or Testing',
    URL: 'https://www.insurancexdate.com/gl/94304',
  },
  {
    Code: 94381,
    Description: 'Fire Suppression Systems--Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/94381',
  },
  {
    Code: 94404,
    Description: 'Fireproofing--Structures',
    URL: 'https://www.insurancexdate.com/gl/94404',
  },
  {
    Code: 94444,
    Description: 'Contractors',
    URL: 'https://www.insurancexdate.com/gl/94444',
  },
  {
    Code: 94569,
    Description: 'Floor Covering Installation--Not Ceramic Tile or Stone',
    URL: 'https://www.insurancexdate.com/gl/94569',
  },
  {
    Code: 94590,
    Description: 'Floor Waxing',
    URL: 'https://www.insurancexdate.com/gl/94590',
  },
  {
    Code: 94617,
    Description:
      'Freight Forwarders or Handlers--Other Than Packing, Handling or Shipping Explosives or Ammunition under Contract',
    URL: 'https://www.insurancexdate.com/gl/94617',
  },
  {
    Code: 94638,
    Description:
      'Freight Forwarders or Handlers--Packing, Handling or Shipping Explosives or Ammunition under Contract',
    URL: 'https://www.insurancexdate.com/gl/94638',
  },
  {
    Code: 95124,
    Description: 'Furniture or Fixtures--Installation in Offices or Stores--Portable--Metal or Wood',
    URL: 'https://www.insurancexdate.com/gl/95124',
  },
  {
    Code: 95233,
    Description: 'Garbage, Ash or Refuse Collecting',
    URL: 'https://www.insurancexdate.com/gl/95233',
  },
  {
    Code: 95305,
    Description: 'Gas Companies',
    URL: 'https://www.insurancexdate.com/gl/95305',
  },
  {
    Code: 95306,
    Description: 'Gas Companies--Natural Gas--Local Distribution',
    URL: 'https://www.insurancexdate.com/gl/95306',
  },
  {
    Code: 95310,
    Description: 'Gas Mains or Connections Construction',
    URL: 'https://www.insurancexdate.com/gl/95310',
  },
  {
    Code: 95357,
    Description: 'Geophysical Exploration--Other',
    URL: 'https://www.insurancexdate.com/gl/95357',
  },
  {
    Code: 95358,
    Description: 'Geophysical Exploration--Seismic Method',
    URL: 'https://www.insurancexdate.com/gl/95358',
  },
  {
    Code: 95410,
    Description: 'Grading of Land',
    URL: 'https://www.insurancexdate.com/gl/95410',
  },
  {
    Code: 95455,
    Description: 'Grain Elevator Operations',
    URL: 'https://www.insurancexdate.com/gl/95455',
  },
  {
    Code: 95487,
    Description: 'Greenhouse Erection',
    URL: 'https://www.insurancexdate.com/gl/95487',
  },
  {
    Code: 95505,
    Description: 'Guniting or Shot-Crete',
    URL: 'https://www.insurancexdate.com/gl/95505',
  },
  {
    Code: 95620,
    Description: 'Gunsmiths',
    URL: 'https://www.insurancexdate.com/gl/95620',
  },
  {
    Code: 95625,
    Description: 'Handyperson',
    URL: 'https://www.insurancexdate.com/gl/95625',
  },
  {
    Code: 95630,
    Description: 'Hazardous Material Contractors',
    URL: 'https://www.insurancexdate.com/gl/95630',
  },
  {
    Code: 95647,
    Description:
      'Heating or Combined Heating and Air Conditioning Systems or Equipment--Dealers or Distributors and Installation, Servicing or Repair--No Liquefied Petroleum Gas (LPG) Equipment Sales or Work',
    URL: 'https://www.insurancexdate.com/gl/95647',
  },
  {
    Code: 95648,
    Description:
      'Heating or Combined Heating and Air Conditioning Systems or Equipment--Dealers or Distributors and Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/95648',
  },
  {
    Code: 96053,
    Description: 'House Furnishings Installation',
    URL: 'https://www.insurancexdate.com/gl/96053',
  },
  {
    Code: 96317,
    Description: 'Inspection and Appraisal Companies--Inspecting for Insurance or Valuation Purposes',
    URL: 'https://www.insurancexdate.com/gl/96317',
  },
  {
    Code: 96408,
    Description: 'Insulation Work--Plastic',
    URL: 'https://www.insurancexdate.com/gl/96408',
  },
  {
    Code: 96409,
    Description: 'Insulation Work--Organic or Plastic in Solid State',
    URL: 'https://www.insurancexdate.com/gl/96409',
  },
  {
    Code: 96410,
    Description: 'Insulation Work--Mineral',
    URL: 'https://www.insurancexdate.com/gl/96410',
  },
  {
    Code: 96611,
    Description: 'Interior Decorators',
    URL: 'https://www.insurancexdate.com/gl/96611',
  },
  {
    Code: 96702,
    Description: 'Irrigation or Drainage System Construction',
    URL: 'https://www.insurancexdate.com/gl/96702',
  },
  {
    Code: 96703,
    Description: 'Irrigation Works Operations',
    URL: 'https://www.insurancexdate.com/gl/96703',
  },
  {
    Code: 96816,
    Description: 'Janitorial Services',
    URL: 'https://www.insurancexdate.com/gl/96816',
  },
  {
    Code: 96872,
    Description: 'Jetty or Breakwater Construction',
    URL: 'https://www.insurancexdate.com/gl/96872',
  },
  {
    Code: 96930,
    Description: 'Web Site Designers',
    URL: 'https://www.insurancexdate.com/gl/96930',
  },
  {
    Code: 97002,
    Description: 'Laboratories--Research, Development or Testing--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/97002',
  },
  {
    Code: 97003,
    Description: 'Laboratories--Research, Development or Testing--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/97003',
  },
  {
    Code: 97047,
    Description: 'Landscape Gardening',
    URL: 'https://www.insurancexdate.com/gl/97047',
  },
  {
    Code: 97050,
    Description: 'Lawn Care Services',
    URL: 'https://www.insurancexdate.com/gl/97050',
  },
  {
    Code: 97111,
    Description: 'Logging and Lumbering',
    URL: 'https://www.insurancexdate.com/gl/97111',
  },
  {
    Code: 97220,
    Description: 'Machine Shops',
    URL: 'https://www.insurancexdate.com/gl/97220',
  },
  {
    Code: 97221,
    Description: 'Machinery or Equipment--Farm--Installation, Servicing, Repair or Erection',
    URL: 'https://www.insurancexdate.com/gl/97221',
  },
  {
    Code: 97222,
    Description: 'Machinery or Equipment--Industrial--Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/97222',
  },
  {
    Code: 97223,
    Description: 'Machinery or Equipment--Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/97223',
  },
  {
    Code: 97308,
    Description: 'Marine Appraisers or Surveyors',
    URL: 'https://www.insurancexdate.com/gl/97308',
  },
  {
    Code: 97447,
    Description: 'Masonry',
    URL: 'https://www.insurancexdate.com/gl/97447',
  },
  {
    Code: 97650,
    Description: 'Metal Erection--Decorative or Artistic',
    URL: 'https://www.insurancexdate.com/gl/97650',
  },
  {
    Code: 97651,
    Description: 'Metal Erection--Frame Structures Iron Work on Outside of Buildings',
    URL: 'https://www.insurancexdate.com/gl/97651',
  },
  {
    Code: 97652,
    Description: 'Metal Erection--In the Construction of Dwellings Not Exceeding 2 Stories in Height',
    URL: 'https://www.insurancexdate.com/gl/97652',
  },
  {
    Code: 97653,
    Description: 'Metal Erection--Nonstructural',
    URL: 'https://www.insurancexdate.com/gl/97653',
  },
  {
    Code: 97654,
    Description:
      'Metal Erection--Steel Lock Gates, Gasholders, Standpipes, Water Towers, Smokestacks, Tanks, Silos, Prison Cells, Fire or Burglarproof Vaults',
    URL: 'https://www.insurancexdate.com/gl/97654',
  },
  {
    Code: 97655,
    Description: 'Metal Erection--Structural',
    URL: 'https://www.insurancexdate.com/gl/97655',
  },
  {
    Code: 98002,
    Description: 'Mining',
    URL: 'https://www.insurancexdate.com/gl/98002',
  },
  {
    Code: 98003,
    Description: 'Mining--Surface',
    URL: 'https://www.insurancexdate.com/gl/98003',
  },
  {
    Code: 98090,
    Description: 'Motion Pictures--Development of Negatives, Printing and All Subsequent Operations',
    URL: 'https://www.insurancexdate.com/gl/98090',
  },
  {
    Code: 98091,
    Description: 'Motion Pictures--Film Distribution or Exchanges--Not Located at Motion Picture Studios',
    URL: 'https://www.insurancexdate.com/gl/98091',
  },
  {
    Code: 98092,
    Description:
      'Motion Pictures--Production--Studios or Outside--All Operations Prior to the Development of Negatives',
    URL: 'https://www.insurancexdate.com/gl/98092',
  },
  {
    Code: 98111,
    Description: 'Office Machines or Appliances--Installation, Inspection, Adjustment or Repair',
    URL: 'https://www.insurancexdate.com/gl/98111',
  },
  {
    Code: 98150,
    Description: 'Oil or Natural Gas Lease Operations',
    URL: 'https://www.insurancexdate.com/gl/98150',
  },
  {
    Code: 98151,
    Description:
      'Oil or Gas Lease Operations--Natural Gas--within the Limits of Any Town or City on the Right-Of-Way of Any Railroad or in Any Ocean, Gulf or Bay',
    URL: 'https://www.insurancexdate.com/gl/98151',
  },
  {
    Code: 98152,
    Description: 'Oil or Gas Lease Work by Contractors--Not Lease Operation',
    URL: 'https://www.insurancexdate.com/gl/98152',
  },
  {
    Code: 98153,
    Description: 'Oil or Gas Wells--Acidizing',
    URL: 'https://www.insurancexdate.com/gl/98153',
  },
  {
    Code: 98154,
    Description: 'Oil or Gas Wells--Cementing',
    URL: 'https://www.insurancexdate.com/gl/98154',
  },
  {
    Code: 98155,
    Description: 'Oil or Gas Wells--Cleaning or Swabbing by Contractors',
    URL: 'https://www.insurancexdate.com/gl/98155',
  },
  {
    Code: 98156,
    Description:
      'Oil or Gas Wells--Cleaning or Swabbing by Contractors--within the Limits of Any Town or City, on the Right-Of-Way of Any Railroad or in Any Ocean, Gulf or Bay',
    URL: 'https://www.insurancexdate.com/gl/98156',
  },
  {
    Code: 98157,
    Description: 'Oil or Gas Wells--Drilling or Redrilling, Installation or Recovery of Casing',
    URL: 'https://www.insurancexdate.com/gl/98157',
  },
  {
    Code: 98158,
    Description:
      'Oil or Gas Wells--Drilling or Redrilling, Installation or Recovery of Casing--within the Limits of Any Town or City, on the Right-Of-Way of Any Railroad or in Any Ocean, Gulf or Bay',
    URL: 'https://www.insurancexdate.com/gl/98158',
  },
  {
    Code: 98159,
    Description: 'Oil or Gas Wells--Instrument Logging or Survey Work in Wells',
    URL: 'https://www.insurancexdate.com/gl/98159',
  },
  {
    Code: 98160,
    Description: 'Oil or Gas Wells--Perforating of Casing',
    URL: 'https://www.insurancexdate.com/gl/98160',
  },
  {
    Code: 98161,
    Description: 'Oil or Gas Wells--Servicing--By Contractors',
    URL: 'https://www.insurancexdate.com/gl/98161',
  },
  {
    Code: 98162,
    Description: 'Oil or Gas Wells--Shooting',
    URL: 'https://www.insurancexdate.com/gl/98162',
  },
  {
    Code: 98163,
    Description: 'Oil Rig or Derrick Erecting or Dismantling--Wood or Metal',
    URL: 'https://www.insurancexdate.com/gl/98163',
  },
  {
    Code: 98164,
    Description: 'Oil Still Erection or Repair',
    URL: 'https://www.insurancexdate.com/gl/98164',
  },
  {
    Code: 98257,
    Description: 'Orchards and Vineyards--Operation by Contractors',
    URL: 'https://www.insurancexdate.com/gl/98257',
  },
  {
    Code: 98303,
    Description: 'Painting--Exterior--Buildings or Structures--Exceeding Three Stories in Height',
    URL: 'https://www.insurancexdate.com/gl/98303',
  },
  {
    Code: 98304,
    Description: 'Painting--Exterior--Buildings or Structures--Three Stories or Less in Height',
    URL: 'https://www.insurancexdate.com/gl/98304',
  },
  {
    Code: 98305,
    Description: 'Painting--Interior--Buildings or Structures',
    URL: 'https://www.insurancexdate.com/gl/98305',
  },
  {
    Code: 98306,
    Description: 'Painting--Oil or Gasoline Tanks',
    URL: 'https://www.insurancexdate.com/gl/98306',
  },
  {
    Code: 98307,
    Description: 'Painting--Ship Hulls',
    URL: 'https://www.insurancexdate.com/gl/98307',
  },
  {
    Code: 98308,
    Description: 'Painting--Shop Only',
    URL: 'https://www.insurancexdate.com/gl/98308',
  },
  {
    Code: 98309,
    Description: 'Painting--Steel Structures or Bridges',
    URL: 'https://www.insurancexdate.com/gl/98309',
  },
  {
    Code: 98344,
    Description: 'Paperhanging',
    URL: 'https://www.insurancexdate.com/gl/98344',
  },
  {
    Code: 98405,
    Description: 'Piano Tuning',
    URL: 'https://www.insurancexdate.com/gl/98405',
  },
  {
    Code: 98413,
    Description: 'Pile Driving--Building Foundation Only',
    URL: 'https://www.insurancexdate.com/gl/98413',
  },
  {
    Code: 98414,
    Description: 'Pile Driving--Other',
    URL: 'https://www.insurancexdate.com/gl/98414',
  },
  {
    Code: 98415,
    Description: 'Pile Driving--Sonic Method',
    URL: 'https://www.insurancexdate.com/gl/98415',
  },
  {
    Code: 98423,
    Description: 'Pipeline Construction--Gas',
    URL: 'https://www.insurancexdate.com/gl/98423',
  },
  {
    Code: 98424,
    Description: 'Pipeline Construction--Other',
    URL: 'https://www.insurancexdate.com/gl/98424',
  },
  {
    Code: 98425,
    Description: 'Pipeline Construction--Oil',
    URL: 'https://www.insurancexdate.com/gl/98425',
  },
  {
    Code: 98426,
    Description: 'Pipeline Construction--Slurry--Nonflammable Mixtures',
    URL: 'https://www.insurancexdate.com/gl/98426',
  },
  {
    Code: 98427,
    Description: 'Pipelines--Operation--Gas',
    URL: 'https://www.insurancexdate.com/gl/98427',
  },
  {
    Code: 98428,
    Description: 'Pipelines--Operation--Other',
    URL: 'https://www.insurancexdate.com/gl/98428',
  },
  {
    Code: 98429,
    Description: 'Pipelines--Operation--Oil',
    URL: 'https://www.insurancexdate.com/gl/98429',
  },
  {
    Code: 98430,
    Description: 'Pipelines--Operation--Slurry--Nonflammable Mixtures',
    URL: 'https://www.insurancexdate.com/gl/98430',
  },
  {
    Code: 98449,
    Description: 'Plastering or Stucco Work',
    URL: 'https://www.insurancexdate.com/gl/98449',
  },
  {
    Code: 98482,
    Description: 'Plumbing--Commercial and Industrial',
    URL: 'https://www.insurancexdate.com/gl/98482',
  },
  {
    Code: 98483,
    Description: 'Plumbing--Residential or Domestic',
    URL: 'https://www.insurancexdate.com/gl/98483',
  },
  {
    Code: 98502,
    Description: 'Prefabricated Building Erection',
    URL: 'https://www.insurancexdate.com/gl/98502',
  },
  {
    Code: 98555,
    Description: 'Quarries',
    URL: 'https://www.insurancexdate.com/gl/98555',
  },
  {
    Code: 98597,
    Description: 'Radio or TV Broadcasting Stations--Other Than Not-For-Profit',
    URL: 'https://www.insurancexdate.com/gl/98597',
  },
  {
    Code: 98598,
    Description: 'Radio or TV Broadcasting Stations--Not-For-Profit Only',
    URL: 'https://www.insurancexdate.com/gl/98598',
  },
  {
    Code: 98601,
    Description: 'Railroad Construction',
    URL: 'https://www.insurancexdate.com/gl/98601',
  },
  {
    Code: 98622,
    Description: 'Railroads--Operation and Maintenance--with BI Passenger Hazard',
    URL: 'https://www.insurancexdate.com/gl/98622',
  },
  {
    Code: 98623,
    Description: 'Railroads--Operation and Maintenance--without BI Passenger Hazard',
    URL: 'https://www.insurancexdate.com/gl/98623',
  },
  {
    Code: 98624,
    Description: 'Railroads--Shop Operation and Maintenance',
    URL: 'https://www.insurancexdate.com/gl/98624',
  },
  {
    Code: 98636,
    Description:
      'Refrigeration Systems or Equipment--Dealers and Distributors and Installation, Servicing or Repair--Commercial',
    URL: 'https://www.insurancexdate.com/gl/98636',
  },
  {
    Code: 98640,
    Description: 'Renovating--Outside Surfaces of Buildings',
    URL: 'https://www.insurancexdate.com/gl/98640',
  },
  {
    Code: 98658,
    Description: 'Rigging--Not Ship or Boat',
    URL: 'https://www.insurancexdate.com/gl/98658',
  },
  {
    Code: 98659,
    Description: 'Rigging--Ship or Boat',
    URL: 'https://www.insurancexdate.com/gl/98659',
  },
  {
    Code: 98677,
    Description: 'Roofing--Commercial or Residential Over Three Stories',
    URL: 'https://www.insurancexdate.com/gl/98677',
  },
  {
    Code: 98678,
    Description: 'Roofing--Residential--Three Stories & Under',
    URL: 'https://www.insurancexdate.com/gl/98678',
  },
  {
    Code: 98698,
    Description: 'Salvage Operations',
    URL: 'https://www.insurancexdate.com/gl/98698',
  },
  {
    Code: 98699,
    Description: 'Salvage Operations--Removing, Sorting, Reconditioning and Distributing of Merchandise in Damaged',
    URL: 'https://www.insurancexdate.com/gl/98699',
  },
  {
    Code: 98705,
    Description: 'Sandblasting',
    URL: 'https://www.insurancexdate.com/gl/98705',
  },
  {
    Code: 98710,
    Description: 'Sand or Gravel Digging',
    URL: 'https://www.insurancexdate.com/gl/98710',
  },
  {
    Code: 98751,
    Description: 'Security and Patrol Agencies',
    URL: 'https://www.insurancexdate.com/gl/98751',
  },
  {
    Code: 98806,
    Description: 'Septic Tank Systems--Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/98806',
  },
  {
    Code: 98810,
    Description: 'Sewage Disposal--Plant Operations',
    URL: 'https://www.insurancexdate.com/gl/98810',
  },
  {
    Code: 98813,
    Description: 'Sewer Cleaning',
    URL: 'https://www.insurancexdate.com/gl/98813',
  },
  {
    Code: 98820,
    Description: 'Sewer Mains or Connections Construction',
    URL: 'https://www.insurancexdate.com/gl/98820',
  },
  {
    Code: 98871,
    Description: 'Shaft Sinking',
    URL: 'https://www.insurancexdate.com/gl/98871',
  },
  {
    Code: 98884,
    Description: 'Sheet Metal Work--Outside',
    URL: 'https://www.insurancexdate.com/gl/98884',
  },
  {
    Code: 98914,
    Description: 'Ship Ceiling or Scaling',
    URL: 'https://www.insurancexdate.com/gl/98914',
  },
  {
    Code: 98949,
    Description: 'Ship Repair or Conversion',
    URL: 'https://www.insurancexdate.com/gl/98949',
  },
  {
    Code: 98967,
    Description: 'Siding Installation',
    URL: 'https://www.insurancexdate.com/gl/98967',
  },
  {
    Code: 98993,
    Description: 'Sign Erection, Installation or Repair',
    URL: 'https://www.insurancexdate.com/gl/98993',
  },
  {
    Code: 99003,
    Description: 'Sign Painting or Lettering--Inside of Buildings',
    URL: 'https://www.insurancexdate.com/gl/99003',
  },
  {
    Code: 99004,
    Description: 'Sign Painting or Lettering--on Buildings or Structures',
    URL: 'https://www.insurancexdate.com/gl/99004',
  },
  {
    Code: 99080,
    Description: 'Solar Energy Contractors',
    URL: 'https://www.insurancexdate.com/gl/99080',
  },
  {
    Code: 99111,
    Description: 'Stables--Boarding, Livery or Racing',
    URL: 'https://www.insurancexdate.com/gl/99111',
  },
  {
    Code: 99160,
    Description: 'Steam Heating or Steam Power Companies',
    URL: 'https://www.insurancexdate.com/gl/99160',
  },
  {
    Code: 99163,
    Description: 'Steam Mains or Connections Construction',
    URL: 'https://www.insurancexdate.com/gl/99163',
  },
  {
    Code: 99165,
    Description: 'Steam Pipe or Boiler Insulation',
    URL: 'https://www.insurancexdate.com/gl/99165',
  },
  {
    Code: 99220,
    Description: 'Stevedoring--By Hand or by Means of Hand Trucks Exclusively--No Hoisting of Cargo',
    URL: 'https://www.insurancexdate.com/gl/99220',
  },
  {
    Code: 99221,
    Description: 'Stevedoring--Handling Explosives or Ammunition--under Contract',
    URL: 'https://www.insurancexdate.com/gl/99221',
  },
  {
    Code: 99222,
    Description: 'Stevedoring',
    URL: 'https://www.insurancexdate.com/gl/99222',
  },
  {
    Code: 99223,
    Description: 'Stevedoring--Tallyers or Checking Clerks Engaged in Connection with Stevedoring Work',
    URL: 'https://www.insurancexdate.com/gl/99223',
  },
  {
    Code: 99303,
    Description: 'Street Cleaning',
    URL: 'https://www.insurancexdate.com/gl/99303',
  },
  {
    Code: 99310,
    Description: 'Snow & Ice Removal--Contractor',
    URL: 'https://www.insurancexdate.com/gl/99310',
  },
  {
    Code: 99315,
    Description: 'Street or Road Construction or Reconstruction',
    URL: 'https://www.insurancexdate.com/gl/99315',
  },
  {
    Code: 99321,
    Description: 'Street or Road Paving or Repaving, Surfacing or Resurfacing or Scraping',
    URL: 'https://www.insurancexdate.com/gl/99321',
  },
  {
    Code: 99471,
    Description: 'Surveyors--Land--Not Engaged in Actual Construction',
    URL: 'https://www.insurancexdate.com/gl/99471',
  },
  {
    Code: 99505,
    Description: 'Swimming Pool Servicing',
    URL: 'https://www.insurancexdate.com/gl/99505',
  },
  {
    Code: 99506,
    Description: 'Swimming Pools--Installation, Servicing or Repair--Above Ground',
    URL: 'https://www.insurancexdate.com/gl/99506',
  },
  {
    Code: 99507,
    Description: 'Swimming Pools--Installation, Servicing or Repair--Below Ground',
    URL: 'https://www.insurancexdate.com/gl/99507',
  },
  {
    Code: 99570,
    Description: 'Tank Construction, Installation, Erection or Repair--Metal--Not Pressurized',
    URL: 'https://www.insurancexdate.com/gl/99570',
  },
  {
    Code: 99571,
    Description: 'Tank Construction, Installation, Erection or Repair--Metal--Pressurized',
    URL: 'https://www.insurancexdate.com/gl/99571',
  },
  {
    Code: 99572,
    Description:
      'Tank Construction, Installation, Erection or Repair--Metal--Not Pressurized--within Buildings Exclusively',
    URL: 'https://www.insurancexdate.com/gl/99572',
  },
  {
    Code: 99573,
    Description:
      'Tank Construction, Installation, Erection or Repair--Metal--Pressurized--within Buildings Exclusively',
    URL: 'https://www.insurancexdate.com/gl/99573',
  },
  {
    Code: 99600,
    Description: 'Telecommunications Service Providers',
    URL: 'https://www.insurancexdate.com/gl/99600',
  },
  {
    Code: 99613,
    Description: 'Telephone, Telegraph or Cable Television Line Construction',
    URL: 'https://www.insurancexdate.com/gl/99613',
  },
  {
    Code: 99614,
    Description: 'Telegraph Companies',
    URL: 'https://www.insurancexdate.com/gl/99614',
  },
  {
    Code: 99620,
    Description: 'Teleproduction Studios',
    URL: 'https://www.insurancexdate.com/gl/99620',
  },
  {
    Code: 99650,
    Description: 'Television or Radio Receiving Set Installation or Repair',
    URL: 'https://www.insurancexdate.com/gl/99650',
  },
  {
    Code: 99709,
    Description: 'Tent or Canvas Goods--Erection, Removal or Repair--Away from Shop',
    URL: 'https://www.insurancexdate.com/gl/99709',
  },
  {
    Code: 99718,
    Description: 'Theatrical Companies--Traveling',
    URL: 'https://www.insurancexdate.com/gl/99718',
  },
  {
    Code: 99746,
    Description: 'Tile, Stone, Marble, Mosaic or Terrazzo Work--Interior Construction',
    URL: 'https://www.insurancexdate.com/gl/99746',
  },
  {
    Code: 99760,
    Description: 'Tobacco Rehandling or Warehousing',
    URL: 'https://www.insurancexdate.com/gl/99760',
  },
  {
    Code: 99777,
    Description: 'Tree Pruning, Dusting, Spraying, Repairing, Trimming or Fumigating',
    URL: 'https://www.insurancexdate.com/gl/99777',
  },
  {
    Code: 99793,
    Description: 'Truckers',
    URL: 'https://www.insurancexdate.com/gl/99793',
  },
  {
    Code: 99798,
    Description: 'Tunneling',
    URL: 'https://www.insurancexdate.com/gl/99798',
  },
  {
    Code: 99803,
    Description: 'Underpinning Buildings or Structures',
    URL: 'https://www.insurancexdate.com/gl/99803',
  },
  {
    Code: 99826,
    Description: 'Upholstering',
    URL: 'https://www.insurancexdate.com/gl/99826',
  },
  {
    Code: 99827,
    Description: 'Upholstering--Shop Only',
    URL: 'https://www.insurancexdate.com/gl/99827',
  },
  {
    Code: 99851,
    Description: 'Veterinarian or Veterinary Hospitals',
    URL: 'https://www.insurancexdate.com/gl/99851',
  },
  {
    Code: 99917,
    Description: 'Warehouse--Cold Storage--Public',
    URL: 'https://www.insurancexdate.com/gl/99917',
  },
  {
    Code: 99938,
    Description: 'Warehouses',
    URL: 'https://www.insurancexdate.com/gl/99938',
  },
  {
    Code: 99943,
    Description: 'Water Companies',
    URL: 'https://www.insurancexdate.com/gl/99943',
  },
  {
    Code: 99946,
    Description: 'Water Mains or Connections Construction',
    URL: 'https://www.insurancexdate.com/gl/99946',
  },
  {
    Code: 99948,
    Description: 'Water Softening Equipment--Installation, Servicing or Repair',
    URL: 'https://www.insurancexdate.com/gl/99948',
  },
  {
    Code: 99952,
    Description: 'Waterproofing--By Pressure Apparatus',
    URL: 'https://www.insurancexdate.com/gl/99952',
  },
  {
    Code: 99953,
    Description: 'Waterproofing--By Trowel--Exterior',
    URL: 'https://www.insurancexdate.com/gl/99953',
  },
  {
    Code: 99954,
    Description: 'Waterproofing--By Trowel--Interior or Insulation Work',
    URL: 'https://www.insurancexdate.com/gl/99954',
  },
  {
    Code: 99955,
    Description: 'Waterproofing',
    URL: 'https://www.insurancexdate.com/gl/99955',
  },
  {
    Code: 99963,
    Description:
      'Weighers, Samplers or Inspectors of Merchandise--on Vessels or Docks or at Railway Stations or Warehouses',
    URL: 'https://www.insurancexdate.com/gl/99963',
  },
  {
    Code: 99969,
    Description: 'Welding or Cutting',
    URL: 'https://www.insurancexdate.com/gl/99969',
  },
  {
    Code: 99975,
    Description: 'Window Cleaning',
    URL: 'https://www.insurancexdate.com/gl/99975',
  },
  {
    Code: 99986,
    Description: 'Wrecking--Buildings or Structures',
    URL: 'https://www.insurancexdate.com/gl/99986',
  },
  {
    Code: 99987,
    Description: 'Wrecking--Dismantling of Prefabricated Dwellings Not Exceeding Three Stories for Reerection',
    URL: 'https://www.insurancexdate.com/gl/99987',
  },
  {
    Code: 99988,
    Description: 'Wrecking--Marine',
    URL: 'https://www.insurancexdate.com/gl/99988',
  },
  {
    Code: 441105,
    Description: 'Governmental: Municipalities--Population 100,001-250,000',
    URL: 'https://www.insurancexdate.com/gl/441105',
  },
];

export default isoglcodes;
